// AAAT - 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
// SAAT - 2861f5e893e2ce31e62c929cc7856923
// APIs URL
var apiURL = "https://aribikes.myshopify.com/api/2024-01/graphql.json";
var token = "2861f5e893e2ce31e62c929cc7856923";

// Use to track preselected options
var preselectedOptions = {};
// Used to add metadata on cart items for parts
var parts = {};

// Used to track what product is on the cart
var selectedVariantID = null;

// fn formatMoney
const formatMoney = (amount) => {
  const formattedPrice = Number(amount).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });

  return formattedPrice; 
};

const formatCartMoney = (amount) => {

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  const formattedPrice = formatter.format(amount / 100);
  return formattedPrice;
}

// extract URL parameters
const getVariantID = (url) => {
  // Regular expression to match the numerical part
  const regex = /\/(\d+)$/;

  // Extracting the numerical part using match method
  const match = url.match(regex);

  // Checking if there's a match
  if (match) {
    // Extracted numerical part
    const productId = match[1];
    return productId;
  }

  return null;
};

// clear cart
const clearCart = async () => {
  try {
    const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
    });
    if (!response.ok) {
        throw new Error('Failed to clear cart');
    }
    console.log('Cart cleared successfully');
  } catch (error) {
      console.error('Error clearing cart:', error);
  }
};

// Disable all buttons
const disabledAllButtons = ($context) => {
  // console.log("Locking all buttons");
  $('body').addClass('waiting')
  $context
    .closest(".product-option-item")
    .find("ul")
    .children()
    .each(function () {
      $(this).addClass("disabled");
    });
};

const unlockingAllButtons = ($context) => {
  // console.log("UnLocking all buttons");
  $('body').removeClass('waiting')
  $context
    .closest(".product-option-item")
    .find("ul")
    .children()
    .each(function () {
      $(this).removeClass("disabled");
    });
};

const searchCartItemKey = (variantID, items) => {
  return items.find((item) => item.key.split(":")[0] === variantID);
}

// get cart Items
const getCartItems = async () => {
  try {
    const request = await fetch('/cart.js');
    if (!request.ok) {
      throw new Error('Failed to get cart');
    }
    return await request.json();
  } catch (error) {
    console.error('Error getting cart:', error);
    return [];
  }
};

//update cart total price
const updateCartTotalPrice = async () => {
  const cartItems = await getCartItems();
  // console.log('cartItems:', cartItems);
  $('.product-price span').text(formatCartMoney(cartItems.total_price));
  $('[data-total-summery-price]').text(formatCartMoney(cartItems.total_price));

  $('[data-subtotal-text]').removeClass('hidden');
  $('[data-price-container]').removeClass('hidden');
  $('[data-checkout-note]').removeClass('hidden');

  return cartItems.total_price;
};

const breadRoundUp = (dollarString) => {
  // parse the dollar string into floating point number
  const amount = parseFloat(dollarString.replace('$', ''));

  // check if amount has decimal part
  if (amount % 1 !== 0) {
      return '$' + Math.ceil(amount);
  }

  return dollarString;
}

const cleanMoney = (amountInString) => {
  return parseFloat(amountInString.replace(/[$,]/g, ''));
}

const updateDisplayPrice = ($context, $selected) => {
  const activePrice = cleanMoney($selected.data('price'));
  // get $context first child
  const $firstChild = $context.find('ul').children()[0];

  $context.find('ul').children().each(function(index) {
    const price = cleanMoney($(this).data('price'));
    console.log("price: ", price, activePrice)
    console.log('compare: ', $firstChild, $selected[0])
    if ($(this) != $selected) {
      // if (price === 0) {
      //   $(this).find('.parts-price').text("- $" + activePrice.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}));
      // } else 
      if (price === 0 && activePrice === 0 && index === 0) {
        $(this).find('.parts-price').text("Included");
      } else if (price > activePrice) {
        $(this).find('.parts-price').text("+ $" + (price - activePrice).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}));
      } else if (price < activePrice) {
        console.log("price here: ", price, activePrice)
        $(this).find('.parts-price').text("- $" + (activePrice - price).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}));
      } else {
        $(this).find('.parts-price').text("");
      }
    }
  })
  $selected.find('.parts-price').text("");
  // If selected is price is 0
  console.log("compare: ", $firstChild == $selected[0]);
  if (activePrice === 0 && $firstChild == $selected[0]) {
    $selected.find('.parts-price').text("Included");
  }
}

// Breadpayment
const updateBreadPayment = async (cartPrice) => {
  // BREAD PAYMENT ON BUILDER
  let breadPlacements = [];
  let placement = {};
  let currency = "USD";
  placement.allowCheckout = false;
  placement.domID = "bread-price";
  placement.order = {};
  placement.order.items = [];
  let price = cartPrice;
  placement.order.subTotal = { value: price, currency: currency };
  placement.order.totalPrice = { value: price, currency: currency };
  placement.order.currency = currency;
  placement.order.totalShipping = { value: 0, currency: currency };
  placement.order.totalTax = { value: 0, currency: currency };
  placement.order.totalDiscounts = { value: 0, currency: currency };
  breadPlacements.push(placement);

  BreadPayments.registerPlacements(breadPlacements);

  var merchantId = "7c30b5a0-acd0-4d18-b443-7b19908889ba";
  var programProductionKeyID = "2a1d717a-e4ea-43fc-9d2b-6844f06eda79";
  var programId = "b7beac2e-2714-4d1d-b110-72e405b41c34";
  var endpointProd = `https://api.platform.breadpayments.com/api/experience/servicing/as-low-as?merchantId=${merchantId}&amount=${cartPrice}&programId=${programProductionKeyID}`;

  const request = await fetch(endpointProd)
    .then((response) => response.json())
    .then((data) => {
      // console.log("data: ", data);
      $("#bread-event-button, #bread-event-button-summary")
        .html("or as low as " + breadRoundUp(data.asLowAs.paymentAmountText["en-us"]) + "/mo*")
        .click((e) => {
          e.preventDefault();
          BreadPayments.on("INSTALLMENT:APPLICATION_DECISIONED", (data) => {
            console.log("Bread Modal:", data)
            if (data && data.billingContact.email) {
              //Middleware to push to Klaviyo
              // fetch(`https://MERCHANT-SITE-URL/bread?email=${data.email}`);
              const customerData = {
                email: data.billingContact.email,
                phone: data.billingContact.phone,
                firstname: data.billingContact.name.givenName || "No Data",
                lastname: data.billingContact.name.familyName || "No Data",
                status: data.status || "No Data",
                city: data.billingContact.address.locality || "No Data",
                rigion: data.billingContact.address.region || "No Data",
                country: data.billingContact.address.country || "No Data",
                postalCode: data.billingContact.address.postalCode || "No Data",
              };

              console.log("customerData: ", customerData);

              // convert data to JSON Format
              const customerDataJson = JSON.stringify(customerData);
              // url
              const breadURL = "https://hooks.zapier.com/hooks/catch/11519004/39xzd24/";

              // Set up fetch options for the POSt request
              const fetchOptions = {
                method: "POST",
                mode: "no-cors",
                headers: {
                  "Accept": "application/json"
                },
                body: customerDataJson,
              };

              // Make the POST request
              fetch(breadURL, fetchOptions)
              .then((response) => {
                console.log("response: ", response);
              })
              .catch((error) => {
                console.error(error);
              });
            }
          });
          BreadPayments.on("INSTALLMENT:APPLICATION_CHECKOUT", () => {});

          BreadPayments.openExperienceForPlacement(breadPlacements);
          // BreadPayments.__internal__.init();
        });
    })
    .catch((error) => {
      console.error(error);
    });

    return request;
}

// Add to cart
const addToCart = async (variantID) => {
  // console.log("Adding to cart");

  try {
    const request = await fetch('/cart/add.js', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantID,
        quantity: 1,
      }),
    })
    
    if(!request.ok) throw new Error('Failed to add to cart');
    const response = await request.json();
    $('#bike-variant').val(response.key);
    return response;
  } catch (error) {
    console.error('Error adding to cart:', error);
    return [];
  }

};

// Add parts to cart
const addPartsToCart = async (variantID, $context) => {
  // console.log("Adding parts to cart");
  // console.log($context)

  // Get part item value
  if ($context.length && $context.val() !== "n/a") {
    await fetch('/cart/change.js', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: $context.val(),
        quantity: 0,
      }),
    });
  }

  try {
    const request = await fetch('/cart/add.js', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantID,
        quantity: 1,
      }),
    })
    
    if(!request.ok) throw new Error('Failed to add to cart');
    const response = await request.json();
    return response;
  } catch (error) {
    console.error('Error adding to cart:', error);
    return [];
  }

}

// Remove from cart
const removeFromCart = async (key) => {
  // console.log("Removing from cart");
  try {
    const request = await fetch('/cart/change.js', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: key,
        quantity: 0,
      }),
    });

    if(!request.ok) throw new Error('Failed to remove from cart');
    const response = await request.json();
    return response;
  } catch (error) {
    console.error('Error removing from cart:', error);
    return [];
  }
};

// Change color of bike variant
const changeBikeProperties = async (key) => {
  // console.log("Changing bike properties");
  const request = await fetch('/cart/change.js', {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: key,
      properties: {
        "Frame Color": $('#bike-variant-color').val(),
        "Bike Size": $('#bike-variant-size').val(),
        "Bike Image": $('#bike-variant-color-image').val(),
      }
    }),
  });

  if(!request.ok) {
    // reload to fix the issue
    location.reload();
  }
  const response = await request.json();
  let item = searchCartItemKey($('#bike-variant').val().split(":")[0], response.items)
  $('#bike-variant').val(item.key);
  return response;
}

// add custom bike part properties
const addCustomFitProperties = async (key) => {
  // console.log("Changing bike properties");
  const request = await fetch('/cart/change.js', {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: key,
      properties: {
        "Frame Color": $('#bike-variant-color').val(),
        "Bike Size": $('#bike-variant-size').val(),
        "Bike Image": $('#bike-variant-color-image').val(),
        "Custom Fit": "Yes",
        "Height": $('#bike-custom-fit-height').val(),
        "Weight": $('#bike-custom-fit-weight').val(),
        "Age": $('#bike-custom-fit-age').val(),
        "Inseam": $('#bike-custom-fit-inseam').val(),
        "Shoulder Width": $('#bike-custom-fit-shoulder-width').val(),
        "Arm Length": $('#bike-custom-fit-arm-length').val(),
        "Torso": $('#bike-custom-fit-torso').val(),
        "Gender": $('#bike-custom-fit-gender').val(),
        "Riding Position": $('#bike-custom-fit-riding-position').val(),
      }
    }),
  });

  if(!request.ok) throw new Error('Failed to change bike properties');
  const response = await request.json();
  let item = searchCartItemKey($('#bike-variant').val().split(":")[0], response.items)
  $('#bike-variant').val(item.key);
  return response;
}

const addBikePartsProperties = async (key, parts) => {
  const request = await fetch('/cart/change.js', {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: key.split(":")[0],
      properties: parts
    }),
  });

  if(!request.ok) throw new Error('Failed to change bike properties');
  const response = await request.json();
  let item = searchCartItemKey($('#bike-variant').val().split(":")[0], response.items)
  $('#bike-variant').val(item.key);
  return response; 
}

// fn Image Carousel
const imageCarousel = (product, images) => {
  // remove existing slides
  $(".product-image-container").height($(".product-image-container").height());
  if (images.length > 0) {
    $(".product-image-container").slick("removeSlide", null, null, true);

    // set product image container to current height so it will not jump when the new images are loaded

    let imagesArr = images
    if (typeof images === "string") {
      imagesArr = JSON.parse(images);
    }

    // add new images slides
    imagesArr.forEach((image) => {
      $(".product-image-container").slick(
        "slickAdd",
        `<div class="product-image-inner-container"><img src="${image.image}" alt="${product.title} Bike"></div>`
      );
    });

    $(".product-image-container").height($(".product-image-container").height());

    // Reinitialize the Slick carousel only if it exists
    if ($(".product-image-container").hasClass("slick-initialized")) {
      $(".product-image-container").slick("unslick"); // Uninitialize Slick
    }

    // Re-init the carousel
    $(".product-image-container").slick({
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      arrows: true,
      prevArrow: `<button class="carousel-nav prev-arrow"><div class="navigation-container"><svg width="100%" height="100%" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L9 9L1 17" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div></button>`,
      nextArrow: `<button class="carousel-nav next-arrow"><div class="navigation-container"><svg width="100%" height="100%" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L9 9L1 17" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div></button>`,
    });
  }

  // Remove loading skeleton
  $(".product-image-container").removeClass("loading-skeleton");
};

// update product price
const updateProductPrice = (bikeTotalPrice, price) => {
  
  $("[data-builder-product-title")
    .find(".product-price span")
    .text(formatMoney(price));

    return bikeTotalPrice += price;
};

// Get Bike Options
const getBikeOptions = (optionHandle) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "POST",
      url: apiURL,
      headers: {
        "X-Shopify-Storefront-Access-Token": token,
        "content-Type": "application/graphql",
      },
      data: `{
            product(handle: "${optionHandle}") {
              id
              title
              description
              variants(first: 16) {
                  edges {
                      node {
                          id
                          price {
                              amount
                          }
                          title
                          image {
                              url
                          }
                          metafields(identifiers: [
                            {
                              namespace: "bike_builder_option",
                              key: "option_tag"
                            },
                            {
                              namespace: "bike_builder_option",
                              key: "option_available"
                            },
                            {
                              namespace: "bike_builder_option",
                              key: "option_package_content"
                            },
                            {
                              namespace: "bike_builder_option",
                              key: "option_description"
                            },
                            {
                              namespace: "bike_builder_option",
                              key: "part_price"
                            },
                            {
                             namespace: "bike_builder_option",
                             key: "is_pricing_max_first"
                            }
                          ]) {
                            key
                            value
                          }
                          availableForSale
                          compareAtPrice {
                              amount
                          }
                      }
                  }
              }
              images(first: 1) {
                  edges {
                      node {
                          url
                          altText
                      }
                  }
              }
            }
        }`,
      success: (results) => {
        resolve(results.data.product?.variants?.edges || null);
      },
      error: (error) => {
        reject(error);
      },
    });
  });
};

// Scroll to target element
const scrollToTarget = ($target, offset = 55) => {
  // console.log("offset", offset)
  const headerHeight = $('#nav-header').outerHeight();
  $("html, body").animate(
    {
      scrollTop: $target.offset().top - headerHeight - offset,
    },
    1000
  );
};

const buildVariantColors = (colors) => {
  if(colors !== null && colors !== "n/a" && colors !== "n-a" && colors !== "" && colors.length !== 0 && colors !== undefined) {
    $("[data-builder-variant-colors]").closest('.product-option-item').removeClass('hidden');
    $("[data-builder-variant-colors]").find("ul").empty();
    colors.forEach((color) => {
      $("[data-builder-variant-colors]").find("ul").append(`
        <li data-carousel-image='${JSON.stringify(color?.image_carousel || [])}' data-variant-color="${color.color_name}" data-frame-size='${JSON.stringify(color?.size || [])}'>
          <a href="#!">
            <div class="product-option-colors-inner-container">
            <span class="color-tag" style="color: ${color?.tag?.text_color}; background-color: ${color?.tag?.bg_color};">${color?.tag?.text || ""}</span>
              <div style="background-color: ${color.color_value}" class="product-option-color color1"></div>
              <div style="background-color: ${color?.color_value_1}" class="product-option-color color2 ${!color?.color_value_1 && "hidden"}"></div>
            </div>
            <span>${color.color_name}</span>
          </a>
        </li>
      `);
    });
  }
}

// BUILD FUNCTIONS
const buildVariantSizes = (sizes, productHandle) => {
  $("[data-builder-sizing-options]").closest('.product-option-item').removeClass('hidden');
  $("[data-builder-sizing-options]").find("ul").empty();
  // console.log("sizes: ", sizes);
  sizes.forEach((size) => {
    $("[data-builder-sizing-options]").find("ul").append(`
      <li data-variant-size="${size.size}" data-est="${size?.est}" data-available="${size.available == "false" ? "0" : "1"}">
        <a href="#!">
          <div class="product-option-size-inner-container ${size.available == "false" && "events-none"}">
              <div class="product-option-size ${size.available == "false" && "out-of-stock"}">
                <span>${size.size}</span>
                <p>${size.available == "true" ? size.est : "Sold Out"}</p>
              </div>
          </div>
        </a>
      </li>
    `);
  });

  $("[data-builder-sizing-options").find("ul").append(`
    <li id="custom-fit-option" class="${productHandle == '801-dirt-jumper' ? 'hidden' : ''}">
      <div class="product-option-size-inner-container events-none">
          <div class="product-detail-size">
            <div class="product-detail-size-heading-container">
              <h4>Custom Fit</h4>
              <svg class="hidden" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="12" cy="12" r="10" stroke="#01d54b" stroke-width="1.5"></circle> <path d="M8.5 12.5L10.5 14.5L15.5 9.5" stroke="#01d54b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
            </div>
            <p>Frame size is only one of the many customizations we do to make sure your bike fits like a glove. 
              Fill out some additional measurements to get a custom fit bike. 
              These measurements can be submitted after you order or skipped completely.
            </p>
          </div>
          <div class="product-detail-action">
              <button data-action-custom-fit>Custom Fit</button> 
              <button data-action-skip>Skip</button>
          </div>
      </div>
    </li>
  `);
};

// Set Bike Options
const buildWheelset = (handle, wheelsetColors) => {
  if (handle !== null && handle !== "n/a" && handle !== "n-a" && handle !== "" && handle.length !== 0 && handle !== undefined) {
    console.log("Wheelset was build");
      let selectedIndexId = null;
      getBikeOptions(handle).then((results) => {
      $("[data-builder-part-wheelset]").closest('.product-option-item').removeClass('hidden').removeClass('disabled');
      $("[data-builder-part-wheelset]").find("ul").empty();
      results.forEach((variant, index) => {
        let optionTag = variant.node.metafields.find((meta) => meta?.key === "option_tag")?.value;
        if (optionTag !== undefined) optionTag = JSON.parse(optionTag);

        let description = variant.node.metafields.find((meta) => meta?.key === "option_description")?.value;
        if (description == undefined) description = null;

        // this is disable that's why it's always true
        let isAvaialable = true;
        // Tracking preselected parts
        if (index === 0) {
          preselectedOptions['Wheelset'] = getVariantID(variant.node.id);
          parts['Wheelset'] = variant.node.title

          // Add active section price
          $("[data-builder-part-wheelset]").attr('data-active-price', variant.node.price.amount === "0.0" ? '$0' : variant.node.price.amount);
        }
        
        let colorJson = "[]";
        if (wheelsetColors !== "n/a" && wheelsetColors !== "n-a" && wheelsetColors !== "" && wheelsetColors.length !== 0 && wheelsetColors !== undefined) {
          const colors = wheelsetColors.filter(color => color.wheel === variant.node.title);
          console.log("Not supposed to print")
          colorJson = JSON.stringify(colors);
        } else {
          colorJson = "[]";
        }

        
        $("[data-builder-part-wheelset]").find("ul").append(`
          <li data-wheel-color='${colorJson}' data-description="${description}" data-product-title="${variant.node.title}" data-featured-image="${variant.node.image.url}" data-price="${variant.node.price.amount === "0.0" ? "$0" : formatMoney(variant.node.price.amount)}" data-price-discount="${variant.node.compareAtPrice === null ? null: formatMoney(variant.node.compareAtPrice?.amount)}" data-variant-id="${variant.node.id}" data-available="${isAvaialable ? "1" : "0"}">
            <a href="#!">
              <div class="product-option-parts-inner-container ${optionTag !== undefined && "part-tags"} ${!isAvaialable && "events-none"} ${index === 0 ? 'active': ''}">
                  <div class="product-option-part-tags ${(optionTag === undefined && variant.node.compareAtPrice === null) && "hidden"}">
                    <span class="${variant.node.compareAtPrice === null && "hidden"}" style="background-color: #AC0000;">Sale</span>
                    <span class="${optionTag === undefined && "hidden"}" style="background-color: ${optionTag?.color}">${optionTag?.tag}</span>
                 </div>
                  <div class="parts-image-container">
                      <img class="${!isAvaialable && "not-available"}" src="${variant.node.image.url}" alt="Wheel">
                  </div>
                  <div class="parts-details-container">
                      <h5>${variant.node.title}</h5>
                      <span class="parts-price">${variant.node.price.amount === "0.0" && index === 0 ? "Included" : "+ " + formatMoney(variant.node.price.amount)}</span>
                      <span class="parts-price-discount ${variant.node.compareAtPrice === null && "hidden"}">${formatMoney(variant.node.compareAtPrice?.amount)}</span>
                  </div>
              </div>
            </a>
          </li>
        `);
      });
    }).catch((error) => {
      // console.log("Error: ", error);
      $("[data-builder-part-wheelset]").find("ul").empty();
    });
  } else {
    $("[data-builder-part-wheelset]").closest('.product-option-item').addClass('hidden');
    $("[data-builder-part-wheelset]").find('ul').empty();
  }
};

const buildDrivetrain = (handle) => {
  if (handle !== null && handle !== "n/a" && handle !== "n-a" && handle !== "" && handle.length !== 0 && handle !== undefined) {
      console.log("Drivetrain was build");
      let selectedIndexId = null;
      getBikeOptions(handle).then((results) => {
      $("[data-builder-part-drivetrain]").closest('.product-option-item').removeClass('hidden').removeClass('disabled');
      $("[data-builder-part-drivetrain]").find("ul").empty();
      results.forEach((variant, index) => {
        let optionTag = variant.node.metafields.find((meta) => meta?.key === "option_tag")?.value;
        if (optionTag !== undefined) optionTag = JSON.parse(optionTag);

        let description = variant.node.metafields.find((meta) => meta?.key === "option_description")?.value;
        if (description == undefined) description = null;

        // this is disable that's why it's always true
        let isAvaialable = true;
        // Tracking preselected parts
        if (index === 0) {
          preselectedOptions['drivetrain'] = getVariantID(variant.node.id);
          parts['Drivetrain'] = variant.node.title

          // console.log("preselectedOptions: ", parts);

          // Add active section price
          $("[data-builder-part-drivetrain]").attr('data-active-price', variant.node.price.amount === "0.0" ? '$0' : variant.node.price.amount);
        }

        $("[data-builder-part-drivetrain]").find("ul").append(`
          <li data-description="${description}" data-product-title="${variant.node.title}" data-featured-image="${variant.node.image.url}" data-price="${variant.node.price.amount === "0.0" ? "$0" : formatMoney(variant.node.price.amount)}" data-price-discount="${variant.node.compareAtPrice === null ? null: formatMoney(variant.node.compareAtPrice?.amount)}" data-variant-id="${variant.node.id}" data-available="${isAvaialable ? "1" : "0"}">
            <a href="#!">
              <div class="product-option-parts-inner-container ${optionTag !== undefined && "part-tags"} ${!isAvaialable && "events-none"} ${index === 0 ? 'active': ''}">
                  <div class="product-option-part-tags ${(optionTag === undefined && variant.node.compareAtPrice === null) && "hidden"}">
                    <span class="${variant.node.compareAtPrice === null && "hidden"}" style="background-color: #AC0000;">Sale</span>
                    <span class="${optionTag === undefined && "hidden"}" style="background-color: ${optionTag?.color}">${optionTag?.tag}</span>
                  </div>
                  <div class="parts-image-container">
                      <img class="${!isAvaialable && "not-available"}" src="${variant.node.image.url}" alt="Wheel">
                  </div>
                  <div class="parts-details-container">
                      <h5>${variant.node.title}</h5>
                      <span class="parts-price">${variant.node.price.amount === "0.0" ? "Included" : "+ " + formatMoney(variant.node.price.amount)}</span>
                      <span class="parts-price-discount ${variant.node.compareAtPrice === null && "hidden"}">${formatMoney(variant.node.compareAtPrice?.amount)}</span>
                  </div>
              </div>
            </a>
          </li>
        `);
      });
    }).catch((error) => {
      // console.log("Error: ", error);
      $("[data-builder-part-drivetrain]").find("ul").empty();
    });
  } else {
    $("[data-builder-part-drivetrain]").closest('.product-option-item').addClass('hidden');
    $("[data-builder-part-drivetrain]").find('ul').empty();
  }
};

const buildCyclingComputer = (handle) => {
  if (handle !== null && handle !== "n/a" && handle !== "n-a" && handle !== "" && handle.length !== 0 && handle !== undefined) {
      console.log("Cycling Computer was build");
      let selectedIndexId = null;
      getBikeOptions(handle).then((results) => {
      $("[data-builder-part-cycling-computer]").closest('.product-option-item').removeClass('hidden').removeClass('disabled');
      $("[data-builder-part-cycling-computer]").find("ul").empty();
      results.forEach((variant, index) => {
        let optionTag = variant.node.metafields.find((meta) => meta?.key === "option_tag")?.value;
        if (optionTag !== undefined) optionTag = JSON.parse(optionTag);

        let description = variant.node.metafields.find((meta) => meta?.key === "option_description")?.value;
        if (description == undefined) description = null;

        // this is disable that's why it's always true
        let isAvaialable = true;
        // Tracking preselected parts
        if (index === 0) {
          preselectedOptions['cycling computer'] = getVariantID(variant.node.id);
          parts['Cycling Computer'] = variant.node.title

          // console.log("preselectedOptions: ", parts);

          // Add active section price
          $("[data-builder-part-cycling-computer]").attr('data-active-price', variant.node.price.amount === "0.0" ? '$0' : variant.node.price.amount);
        }

        $("[data-builder-part-cycling-computer]").find("ul").append(`
          <li data-description="${description}" data-product-title="${variant.node.title}" data-featured-image="${variant.node.image.url}" data-price="${variant.node.price.amount === "0.0" ? "$0" : formatMoney(variant.node.price.amount)}" data-price-discount="${variant.node.compareAtPrice === null ? null: formatMoney(variant.node.compareAtPrice?.amount)}" data-variant-id="${variant.node.id}" data-available="${isAvaialable ? "1" : "0"}">
            <a href="#!">
              <div class="product-option-parts-inner-container ${optionTag !== undefined && "part-tags"} ${!isAvaialable && "events-none"} ${index === 0 ? 'active': ''}">
                  <div class="product-option-part-tags ${(optionTag === undefined && variant.node.compareAtPrice === null) && "hidden"}">
                    <span class="${variant.node.compareAtPrice === null && "hidden"}" style="background-color: #AC0000;">Sale</span>
                    <span class="${optionTag === undefined && "hidden"}" style="background-color: ${optionTag?.color}">${optionTag?.tag}</span>
                  </div>
                  <div class="parts-image-container">
                      <img class="${!isAvaialable && "not-available"}" src="${variant.node.image.url}" alt="Wheel">
                  </div>
                  <div class="parts-details-container">
                      <h5>${variant.node.title}</h5>
                      <span class="parts-price">${variant.node.price.amount === "0.0" ? "Included" : "+ " + formatMoney(variant.node.price.amount)}</span>
                      <span class="parts-price-discount ${variant.node.compareAtPrice === null && "hidden"}">${formatMoney(variant.node.compareAtPrice?.amount)}</span>
                  </div>
              </div>
            </a>
          </li>
        `);
      });
    }).catch((error) => {
      // console.log("Error: ", error);
      $("[data-builder-part-cycling-computer]").find("ul").empty();
    });
  } else {
    $("[data-builder-part-cycling-computer]").closest('.product-option-item').addClass('hidden');
    $("[data-builder-part-cycling-computer]").find('ul').empty();
  }
};

// build popup content compare products
const buildCompareProducts = ($context) => {
  $('[data-compare-popup]').find('ul').empty();

  //loop through all ul li
  $context.closest('.product-option-item').find('ul').children().each(function () {
    // console.log("this: ", $(this))
    $('[data-compare-popup]').find('ul').append(`
    <li>
        <div class="custom-compare-content-container">
            <div class="content-image">
                <img src="${$(this).data('featured-image')}" alt="${$(this).data('product-title')}">
            </div>
            <div class="content-description">
                <h5>${$(this).data('product-title')}</h5>
                <span class="price">${$(this).data('price') == null ? 'Included': $(this).data('price')}</span>
                <span class="original-price ${$(this).data('price-discount') == null && 'hidden'}">${$(this).data('price-discount')}</span>
                <p>${$(this).data('description') !== null ? $(this).data('description') : "No description added for this product."}</p>
            </div>
        </div>
    </li>
    `)
  });
}

const buildPackage = (handle) => {
  if (handle !== null && handle !== "n/a" && handle !== "n-a" && handle !== "" && handle.length !== 0 && handle !== undefined) {
    getBikeOptions(handle).then((results) => {
      $("[data-builder-item-package]").find("ul").first().empty();
      results.forEach((variant) => {
        var optionTag = variant.node.metafields.find((meta) => meta?.key === "option_tag")?.value;
        if (optionTag !== undefined) optionTag = JSON.parse(optionTag);
        let packageContent = variant.node.metafields.find((meta) => meta?.key === "option_package_content")?.value;
        $("[data-builder-item-package]").find("ul").first().append(`
          <li data-variant-id="${variant.node.id}">
            <a href="#!">
              <div class="product-option-package-inner-container ${optionTag !== undefined && "tags"}">
                  <div class="product-option-part-tags ${(optionTag === undefined && variant.node.compareAtPrice === null) && "hidden"}">
                  <span class="${variant.node.compareAtPrice === null && "hidden"}" style="background-color: #AC0000;">Sale</span>
                  <span class="${optionTag === undefined && "hidden"}" style="background-color: ${optionTag?.color}">${optionTag?.tag}</span>
                </div>
                  <div class="package-top-headings">
                      <h5>Base Package</h5>
                      <div class="package-prices">
                          <span class="package-price ${variant.node.price.amount == "0.0" && 'hidden'}">${formatMoney(variant.node.price.amount)}</span>
                          <span class="package-original-price ${variant.node.compareAtPrice == null && 'hidden'}">${formatMoney(variant.node.compareAtPrice?.amount)}</span>
                      </div>
                  </div>
                  <div class="package-details-container">${packageContent || "No Content"}</div>
              </div>
            </a>
          </li>
        `);
      });
    }).catch((error) => {
      // console.log("Error: ", error);
      $("[data-builder-item-package]").find("ul").empty();
    });
  }
};

const buildPedals = (handle) => {
  if (handle !== null && handle !== "n/a" && handle !== "n-a" && handle !== "" && handle.length !== 0 && handle !== undefined) {
    console.log("Pedals was build");
     getBikeOptions(handle).then((results) => {
      $("[data-builder-part-pedals]").closest('.product-option-item').removeClass('hidden').removeClass('disabled');
      $("[data-builder-part-pedals]").find("ul").empty();
      results.forEach((variant, index) => {
        var optionTag = variant.node.metafields.find(
          (meta) => meta?.key === "option_tag"
        )?.value;
        if (optionTag !== undefined) optionTag = JSON.parse(optionTag);
        // TODO: add tags
        let description = variant.node.metafields.find((meta) => meta?.key === "option_description")?.value;
        if (description == undefined) description = null;
        
        // this is disable that's why it's always true
        let isAvaialable = true
        // Tracking preselected parts
        if (index === 0) {
          preselectedOptions['Pedals'] = getVariantID(variant.node.id);
          parts['Pedals'] = variant.node.title
        }

        // Tracking preselected parts
        if (index === 0) {
          preselectedOptions['Pedals'] = getVariantID(variant.node.id);
          parts['Pedals'] = variant.node.title

          //  Add active section price
          $("[data-builder-part-pedals]").attr('data-active-price', variant.node.price.amount === "0.0" ? '$0' : variant.node.price.amount);
        }

        $("[data-builder-part-pedals]").find("ul").append(`
          <li data-description="${description}" data-product-title="${variant.node.title}" data-featured-image="${variant.node.image.url}" data-price="${variant.node.price.amount === "0.0" ? "$0" : formatMoney(variant.node.price.amount)}" data-price-discount="${variant.node.compareAtPrice === null ? null: formatMoney(variant.node.compareAtPrice?.amount)}" data-variant-id="${variant.node.id}" data-variant-price="${variant.node.price?.amount}" data-available="${isAvaialable ? "1" : "0"}">
            <a href="#!">
              <div class="product-option-parts-inner-container ${optionTag !== undefined && "part-tags"} ${!isAvaialable && "events-none"} ${index === 0 ? 'active': ''}">
                <div class="product-option-part-tags ${(optionTag === undefined && variant.node.compareAtPrice === null) && "hidden"}">
                  <span class="${variant.node.compareAtPrice === null && "hidden"}" style="background-color: #AC0000;">Sale</span>
                  <span class="${optionTag === undefined && "hidden"}" style="background-color: ${optionTag?.color}">${optionTag?.tag}</span>
                </div>
                <div class="parts-image-container">
                  <img class="${!isAvaialable && "not-available"}" src="${variant.node.image.url}" alt="Wheel">
                </div>
                <div class="parts-details-container">
                  <h5>${variant.node.title}</h5>
                  <span class="parts-price">${variant.node.price.amount === "0.0" ? "Included" : "+ " + formatMoney(variant.node.price.amount)}</span>
                  <span class="parts-price-discount ${variant.node.compareAtPrice === null && "hidden"}">${formatMoney(variant.node.compareAtPrice?.amount)}</span>
                </div>
              </div>
            </a>
          </li>
        `);
      });
    }).catch((error) => {
      // console.log("Error: ", error);
      $("[data-builder-part-pedals]").find("ul").empty();
    });
  } else {
    $("[data-builder-part-pedals]").closest('.product-option-item').addClass('hidden');
    $("[data-builder-part-pedals]").find('ul').empty();
  }
};

const buildSeatpost = (handle) => {
  if (handle !== null && handle !== "n/a" && handle !== "n-a" && handle !== "" && handle.length !== 0 && handle !== undefined) {
    console.log("Seatpost was build");
     getBikeOptions(handle).then((results) => {
      $("[data-builder-part-seatpost]").closest('.product-option-item').removeClass('hidden').removeClass('disabled');
      $("[data-builder-part-seatpost]").find("ul").empty();
      results.forEach((variant, index) => {
        var optionTag = variant.node.metafields.find(
          (meta) => meta?.key === "option_tag"
        )?.value;
        if (optionTag !== undefined) optionTag = JSON.parse(optionTag);

        let description = variant.node.metafields.find((meta) => meta?.key === "option_description")?.value;
        if (description == undefined) description = null;

        var isAvaialable = variant.node.metafields.find(
          (meta) => meta?.key === "option_available"
        )?.value;

        // Tracking preselected parts
        if (index === 0) {
          preselectedOptions['Seatpost'] = getVariantID(variant.node.id);
          parts['Seatpost'] = variant.node.title

          // Add active section price
          $("[data-builder-part-seatpost]").attr('data-active-price', variant.node.price.amount === "0.0" ? '$0' : variant.node.price.amount);
        }

        $("[data-builder-part-seatpost]").find("ul").append(`
          <li data-description="${description}" data-product-title="${variant.node.title}" data-featured-image="${variant.node.image.url}" data-price="${variant.node.price.amount === "0.0" ? "$0" : formatMoney(variant.node.price.amount)}" data-price-discount="${variant.node.compareAtPrice === null ? null: formatMoney(variant.node.compareAtPrice?.amount)}" data-variant-id="${variant.node.id}" data-variant-price="${variant.node.price?.amount}" data-available="${isAvaialable !== undefined ? "0" : "1"}">
            <a href="#!">
              <div class="product-option-parts-inner-container ${optionTag !== undefined && "part-tags"} ${isAvaialable !== undefined && "events-none"} ${index === 0 ? 'active': ''}">
                <div class="product-option-part-tags ${(optionTag === undefined && variant.node.compareAtPrice === null) && "hidden"}">
                  <span class="${variant.node.compareAtPrice === null && "hidden"}" style="background-color: #AC0000;">Sale</span>
                  <span class="${optionTag === undefined && "hidden"}" style="background-color: ${optionTag?.color}">${optionTag?.tag}</span>
                </div>
                <div class="parts-image-container ${!variant.node.image?.url && 'hidden'}">
                  <img class="${isAvaialable !== undefined && "not-available"}" src="${variant.node.image?.url}" alt="Wheel">
                </div>
                <div class="parts-details-container">
                  <h5>${isAvaialable !== undefined ? "No Pedals" : variant.node.title}</h5>
                  <span class="parts-price">${isAvaialable !== undefined || variant.node.price?.amount == "0.0" ? "Included" : "+ " + formatMoney(variant.node.price.amount)}</span>
                  <span class="parts-price-discount ${variant.node.compareAtPrice === null && "hidden"}">${formatMoney(variant.node.compareAtPrice?.amount)}</span>
                </div>
              </div>
            </a>
          </li>
        `);
      });
    }).catch((error) => {
      // console.log("Error: ", error);
      $("[data-builder-part-pedals]").find("ul").empty();
    });
  } else {
    $("[data-builder-part-seatpost]").closest('.product-option-item').addClass('hidden');
    $("[data-builder-part-seatpost]").find('ul').empty();
  }
}

const buildSuspensionTravel = (handle) => {
  if (handle !== null && handle !== "n/a" && handle !== "n-a" && handle !== "" && handle.length !== 0 && handle !== undefined) {
    console.log("Suspension Travel was build");
    getBikeOptions(handle).then((results) => {
      $("[data-builder-part-suspension-travel]").closest('.product-option-item').removeClass('hidden').removeClass('disabled');
      $("[data-builder-part-suspension-travel]").find("ul").empty();
      results.forEach((variant, index) => {
        // console.log("suspensions: ", variant)
        var optionTag = variant.node.metafields.find(
          (meta) => meta?.key === "option_tag"
        )?.value;
        if (optionTag !== undefined) optionTag = JSON.parse(optionTag);

        let description = variant.node.metafields.find((meta) => meta?.key === "option_description")?.value;
        if (description == undefined) description = null;

        var isAvaialable = variant.node.metafields.find(
          (meta) => meta?.key === "option_available"
        )?.value;

        // Tracking preselected parts
        if (index === 0) {
          preselectedOptions['Suspension Travel'] = getVariantID(variant.node.id);
          parts['Suspension Travel'] = variant.node.title
        }

        $("[data-builder-part-suspension-travel]").find("ul").append(`
          <li data-description="${description}" data-product-title="${variant.node.title}" data-featured-image="${variant.node.image.url}" data-price="${variant.node.price.amount === "0.0" ? null : formatMoney(variant.node.price.amount)}" data-price-discount="${variant.node.compareAtPrice === null ? null: formatMoney(variant.node.compareAtPrice?.amount)}" data-variant-id="${variant.node.id}" data-variant-price="${variant.node.price?.amount}" data-available="${isAvaialable !== undefined ? "0" : "1"}">
            <a href="#!">
              <div class="product-option-parts-inner-container ${!variant.node.image?.url && 'no-image'} ${optionTag !== undefined && "part-tags"} ${isAvaialable !== undefined && "events-none"} ${index === 0 ? 'active': ''}">
                <div class="product-option-part-tags ${(optionTag === undefined && variant.node.compareAtPrice === null) && "hidden"}">
                  <span class="${variant.node.compareAtPrice === null && "hidden"}" style="background-color: #AC0000;">Sale</span>
                  <span class="${optionTag === undefined && "hidden"}" style="background-color: ${optionTag?.color}">${optionTag?.tag}</span>
                </div>
                <div class="parts-image-container ${!variant.node.image?.url && 'hidden'}">
                  <img class="${isAvaialable !== undefined && "not-available"}" src="${variant.node.image?.url}" alt="Wheel">
                </div>
                <div class="parts-details-container">
                  <h5>${isAvaialable !== undefined ? "No Pedals" : variant.node.title}</h5>
                  <span class="parts-price">${isAvaialable !== undefined || variant.node.price?.amount == "0.0" ? "Included" : "+ " + formatMoney(variant.node.price.amount)}</span>
                  <span class="parts-price-discount ${variant.node.compareAtPrice === null && "hidden"}">${formatMoney(variant.node.compareAtPrice?.amount)}</span>
                </div>
              </div>
            </a>
          </li>
        `);
      });
    }).catch((error) => {
      // console.log("Error: ", error);
      $("[data-builder-part-suspension-travel]").find('ul').empty();
    });
  } else {
    $("[data-builder-part-suspension-travel]").closest('.product-option-item').addClass('hidden');
    $("[data-builder-part-suspension-travel]").find('ul').empty();
  }
}

const buildFlatProtection = (handle) => {
  if (handle !== null && handle !== "n/a" && handle !== "n-a" && handle !== "" && handle.length !== 0 && handle !== undefined) {
    console.log("Flat Protection was build");
    getBikeOptions(handle).then((results) => {
      $("[data-builder-part-flat-protection]").closest('.product-option-item').removeClass('hidden').removeClass('disabled');
      $("[data-builder-part-flat-protection]").find("ul").empty();
      results.forEach((variant, index) => {
        var optionTag = variant.node.metafields.find(
          (meta) => meta?.key === "option_tag"
        )?.value;
        if (optionTag !== undefined) optionTag = JSON.parse(optionTag);

        let description = variant.node.metafields.find((meta) => meta?.key === "option_description")?.value;
        if (description == undefined) description = null;

        var isAvaialable = variant.node.metafields.find(
          (meta) => meta?.key === "option_available"
        )?.value;

        // Tracking preselected parts
        if (index === 0) {
          preselectedOptions['Flat Protection'] = getVariantID(variant.node.id);
          parts['Flat Protection'] = variant.node.title

          // Add active section price
          $("[data-builder-part-flat-protection]").attr('data-active-price', variant.node.price.amount === "0.0" ? '$0' : variant.node.price.amount);
        }

        $("[data-builder-part-flat-protection]").find("ul").append(`
          <li data-description="${description}" data-product-title="${variant.node.title}" data-featured-image="${variant.node.image.url}" data-price="${variant.node.price.amount === "0.0" ? "$0" : formatMoney(variant.node.price.amount)}" data-price-discount="${variant.node.compareAtPrice === null ? null: formatMoney(variant.node.compareAtPrice?.amount)}" data-variant-id="${variant.node.id}" data-variant-price="${variant.node.price?.amount}" data-available="${isAvaialable !== undefined ? "0" : "1"}">
            <a href="#!">
              <div class="product-option-parts-inner-container ${!variant.node.image?.url && 'no-image'} ${optionTag !== undefined && "part-tags"} ${isAvaialable !== undefined && "events-none"} ${index === 0 ? 'active': ''}">
                <div class="product-option-part-tags ${(optionTag === undefined && variant.node.compareAtPrice === null) && "hidden"}">
                  <span class="${variant.node.compareAtPrice === null && "hidden"}" style="background-color: #AC0000;">Sale</span>
                  <span class="${optionTag === undefined && "hidden"}" style="background-color: ${optionTag?.color}">${optionTag?.tag}</span>
                </div>
                <div class="parts-image-container ${!variant.node.image?.url && 'hidden'}">
                  <img class="${isAvaialable !== undefined && "not-available"}" src="${variant.node.image?.url}" alt="Wheel">
                </div>
                <div class="parts-details-container">
                  <h5>${isAvaialable !== undefined ? "No Pedals" : variant.node.title}</h5>
                  <span class="parts-price">${isAvaialable !== undefined || variant.node.price?.amount == "0.0" ? "Included" : "+ " + formatMoney(variant.node.price.amount)}</span>
                  <span class="parts-price-discount ${variant.node.compareAtPrice === null && "hidden"}">${formatMoney(variant.node.compareAtPrice?.amount)}</span>
                </div>
              </div>
            </a>
          </li>
        `);
      });
    }).catch((error) => {
      // console.log("Error: ", error);
      $("[data-builder-part-flat-protection]").find('ul').empty();
    });
  } else {
    $("[data-builder-part-flat-protection]").closest('.product-option-item').addClass('hidden');
    $("[data-builder-part-flat-protection]").find('ul').empty();
  }
}

const buildFrameProtection = (handle) => {
  if (handle !== null && handle !== "n/a" && handle !== "n-a" && handle !== "" && handle.length !== 0 && handle !== undefined) {
    console.log("Frame Protection was build");
    getBikeOptions(handle).then((results) => {
      $("[data-builder-part-frame-protection]").closest('.product-option-item').removeClass('hidden').removeClass('disabled');
      $("[data-builder-part-frame-protection]").find("ul").empty();
      results.forEach((variant, index) => {
        var optionTag = variant.node.metafields.find(
          (meta) => meta?.key === "option_tag"
        )?.value;
        if (optionTag !== undefined) optionTag = JSON.parse(optionTag);

        let description = variant.node.metafields.find((meta) => meta?.key === "option_description")?.value;
        if (description == undefined) description = null;

        var isAvaialable = variant.node.metafields.find(
          (meta) => meta?.key === "option_available"
        )?.value;

        // Tracking preselected parts
        if (index === 0) {
          preselectedOptions['Frame Protection'] = getVariantID(variant.node.id);
          parts['Frame Protection'] = variant.node.title

          // Add active section price
          $("[data-builder-part-frame-protection]").attr('data-active-price', variant.node.price.amount === "0.0" ? '$0' : variant.node.price.amount);
        }

        $("[data-builder-part-frame-protection]").find("ul").append(`
          <li data-description="${description}" data-product-title="${variant.node.title}" data-featured-image="${variant.node.image.url}" data-price="${variant.node.price.amount === "0.0" ? "$0" : formatMoney(variant.node.price.amount)}" data-price-discount="${variant.node.compareAtPrice === null ? null: formatMoney(variant.node.compareAtPrice?.amount)}" data-variant-id="${variant.node.id}" data-variant-price="${variant.node.price?.amount}" data-available="${isAvaialable !== undefined ? "0" : "1"}">
            <a href="#!">
              <div class="product-option-parts-inner-container ${!variant.node.image?.url && 'no-image'} ${optionTag !== undefined && "part-tags"} ${isAvaialable !== undefined && "events-none"} ${index === 0 ? 'active': ''}">
               <div class="product-option-part-tags ${(optionTag === undefined && variant.node.compareAtPrice === null) && "hidden"}">
                  <span class="${variant.node.compareAtPrice === null && "hidden"}" style="background-color: #AC0000;">Sale</span>
                  <span class="${optionTag === undefined && "hidden"}" style="background-color: ${optionTag?.color}">${optionTag?.tag}</span>
                </div>
                <div class="parts-image-container ${!variant.node.image?.url && 'hidden'}">
                  <img class="${isAvaialable !== undefined && "not-available"}" src="${variant.node.image?.url}" alt="Wheel">
                </div>
                <div class="parts-details-container">
                  <h5>${isAvaialable !== undefined ? "No Pedals" : variant.node.title}</h5>
                  <span class="parts-price">${isAvaialable !== undefined || variant.node.price?.amount == "0.0" ? "Included" : "+ " + formatMoney(variant.node.price.amount)}</span>
                  <span class="parts-price-discount ${variant.node.compareAtPrice === null && "hidden"}">${formatMoney(variant.node.compareAtPrice?.amount)}</span>
                </div>
              </div>
            </a>
          </li>
        `);
      });
    }).catch((error) => {
      // console.log("Error: ", error);
      $("[data-builder-part-frame-protection]").find('ul').empty();
    });
  } else {
    $("[data-builder-part-frame-protection]").closest('.product-option-item').addClass('hidden');
    $("[data-builder-part-frame-protection]").find('ul').empty();
  }
}

const buildBattery = (handle) => {
  if (handle !== null && handle !== "n/a" && handle !== "n-a" && handle !== "" && handle.length !== 0 && handle !== undefined) {
    console.log("Battery was build");
    getBikeOptions(handle).then((results) => {
      $("[data-builder-part-battery]").closest('.product-option-item').removeClass('hidden').removeClass('disabled');
      $("[data-builder-part-battery]").find("ul").empty();

      var compareThisPrice = 0;

      results.forEach((variant, index) => {
        console.log("part results: ", variant);
        console.log('battery index: ', index);
        var optionTag = variant.node.metafields.find(
          (meta) => meta?.key === "option_tag"
        )?.value;
        if (optionTag !== undefined) optionTag = JSON.parse(optionTag);

        let description = variant.node.metafields.find((meta) => meta?.key === "option_description")?.value;
        if (description == undefined) description = null;

        var isAvaialable = variant.node.metafields.find(
          (meta) => meta?.key === "option_available"
        )?.value;

        // Check if battery is reverse pricing : price with high to low
        let isPricingMaxFirst = variant.node.metafields.find((meta) => meta?.key === "is_pricing_max_first")?.value;
        
        let partPrice = variant.node.metafields.find((meta) => meta?.key === "part_price")?.value;

        // Tracking preselected parts
        if (index === 0) {
          preselectedOptions['Battery'] = getVariantID(variant.node.id);
          parts['Battery'] = variant.node.title

          // Add active section price
          $("[data-builder-part-battery]").attr('data-active-price', variant.node.price.amount === "0.0" ? '$0' : variant.node.price.amount);
        }

        var partOrginalPrice = "$0";
        if (variant.node.price.amount === "0.0") {
          if (isPricingMaxFirst === 'true') {
            compareThisPrice = Number(partPrice);
            partOrginalPrice = formatMoney(partPrice);
          } else {
            partOrginalPrice = "$0";
          }
        } else {
          partOrginalPrice = formatMoney(variant.node.price.amount);
        }

        let displayPrice = "";

        // ${isAvaialable !== undefined || variant.node.price?.amount == "0.0" ? "Included" : "+ " + formatMoney(variant.node.price.amount)}

        if (isAvaialable !== undefined || variant.node.price?.amount == "0.0") {
          displayPrice = "Included";
        } else {
          const currentPrice = Number(variant.node.price.amount);
          if (compareThisPrice > currentPrice) {
            displayPrice = " - " + formatMoney(compareThisPrice - currentPrice);
          } else {
            displayPrice = " + " + formatMoney(currentPrice);
          }
        }

        $("[data-builder-part-battery]").find("ul").append(`
          <li data-description="${description}" data-is-priced-max="${isPricingMaxFirst == 'true' ? 'true' : 'false'}"
          data-part-price="${partPrice}" data-product-title="${variant.node.title}" data-featured-image="${variant.node.image.url}" data-price="${partOrginalPrice}" data-price-discount="${variant.node.compareAtPrice === null ? null: formatMoney(variant.node.compareAtPrice?.amount)}" data-variant-id="${variant.node.id}" data-variant-price="${variant.node.price?.amount}" data-available="${isAvaialable !== undefined ? "0" : "1"}">
            <a href="#!">
              <div class="product-option-parts-inner-container ${!variant.node.image?.url && 'no-image'} ${optionTag !== undefined && "part-tags"} ${isAvaialable !== undefined && "events-none"} ${index === 0 ? 'active': 'notactive'}">
               <div class="product-option-part-tags ${(optionTag === undefined && variant.node.compareAtPrice === null) && "hidden"}">
                  <span class="${variant.node.compareAtPrice === null && "hidden"}" style="background-color: #AC0000;">Sale</span>
                  <span class="${optionTag === undefined && "hidden"}" style="background-color: ${optionTag?.color}">${optionTag?.tag}</span>
                </div>
                <div class="parts-image-container ${!variant.node.image?.url && 'hidden'}">
                  <img class="${isAvaialable !== undefined && "not-available"}" src="${variant.node.image?.url}" alt="Wheel">
                </div>
                <div class="parts-details-container">
                  <h5>${isAvaialable !== undefined ? "No Pedals" : variant.node.title}</h5>
                  <span class="parts-price">${displayPrice}</span>
                  <span class="parts-price-discount ${variant.node.compareAtPrice === null && "hidden"}">${formatMoney(variant.node.compareAtPrice?.amount)}</span>
                </div>
              </div>
            </a>
          </li>
        `);
      });
    }).catch((error) => {
      // console.log("Error: ", error);
      $("[data-builder-part-battery]").find('ul').empty();
    });
  } else {
    $("[data-builder-part-battery]").closest('.product-option-item').addClass('hidden');
    $("[data-builder-part-battery]").find('ul').empty();
  }
}

const buildHandlebar = (handle) => {
  if (handle !== null && handle !== "n/a" && handle !== "n-a" && handle !== "" && handle.length !== 0 && handle !== undefined) {
    console.log("Handlebar was build");
    getBikeOptions(handle).then((results) => {
      $("[data-builder-part-handlebar]").closest('.product-option-item').removeClass('hidden').removeClass('disabled');
      $("[data-builder-part-handlebar]").find("ul").empty();
      results.forEach((variant, index) => {
        console.log('handlebar index: ', index);
        var optionTag = variant.node.metafields.find(
          (meta) => meta?.key === "option_tag"
        )?.value;
        if (optionTag !== undefined) optionTag = JSON.parse(optionTag);

        let description = variant.node.metafields.find((meta) => meta?.key === "option_description")?.value;
        if (description == undefined) description = null;

        var isAvaialable = variant.node.metafields.find(
          (meta) => meta?.key === "option_available"
        )?.value;

        // Tracking preselected parts
        if (index === 0) {
          preselectedOptions['Handlebar'] = getVariantID(variant.node.id);
          parts['Handlebar'] = variant.node.title

          // Add active section price
          $("[data-builder-part-handlebar]").attr('data-active-price', variant.node.price.amount === "0.0" ? '$0' : variant.node.price.amount);
        }
        // TO DO: investigate why its not updating 
        var variantAmount = "";
        if (variant.node.price.amount === "0.0" && index === 0) {
          variantAmount = "Included";
        } else if (variant.node.price.amount !== "0.0") {
          variantAmount = "+ " + formatMoney(variant.node.price.amount);
        }
        $("[data-builder-part-handlebar]").find("ul").append(` 
          <li data-description="${description}" data-product-title="${variant.node.title}" data-featured-image="${variant.node.image.url}" data-price="${variant.node.price.amount === "0.0" ? "$0" : formatMoney(variant.node.price.amount)}" data-price-discount="${variant.node.compareAtPrice === null ? null: formatMoney(variant.node.compareAtPrice?.amount)}" data-variant-id="${variant.node.id}" data-variant-price="${variant.node.price?.amount}" data-available="${isAvaialable !== undefined ? "0" : "1"}">
            <a href="#!">
              <div class="product-option-parts-inner-container ${!variant.node.image?.url && 'no-image'} ${optionTag !== undefined && "part-tags"} ${isAvaialable !== undefined && "events-none"} ${index === 0 ? 'active': 'notactive'}"> 
               <div class="product-option-part-tags ${(optionTag === undefined && variant.node.compareAtPrice === null) && "hidden"}">
                  <span class="${variant.node.compareAtPrice === null && "hidden"}" style="background-color: #AC0000;">Sale</span>
                  <span class="${optionTag === undefined && "hidden"}" style="background-color: ${optionTag?.color}">${optionTag?.tag}</span>
                </div>
                <div class="parts-image-container ${!variant.node.image?.url && 'hidden'}">
                  <img class="${isAvaialable !== undefined && "not-available"}" src="${variant.node.image?.url}" alt="Wheel">
                </div>
                <div class="parts-details-container">
                  <h5>${isAvaialable !== undefined ? "No Pedals" : variant.node.title}</h5>
                  <span class="parts-price">${variantAmount}</span>
                  <span class="parts-price-discount ${variant.node.compareAtPrice === null && "hidden"}">${formatMoney(variant.node.compareAtPrice?.amount)}</span>
                </div>
              </div>
            </a>
          </li>
        `);
      });
    }).catch((error) => {
      // console.log("Error: ", error);
      $("[data-builder-part-handlebar]").find('ul').empty();
    });
  } else {
    $("[data-builder-part-handlebar]").closest('.product-option-item').addClass('hidden');
    $("[data-builder-part-handlebar]").find('ul').empty();
  }
}

const buildSuspension = (handle) => {
  if (handle !== null && handle !== "n/a" && handle !== "n-a" && handle !== "" && handle.length !== 0 && handle !== undefined) {
    console.log("Suspension was build");
    getBikeOptions(handle).then((results) => {
      $("[data-builder-part-suspension]").closest('.product-option-item').removeClass('hidden').removeClass('disabled');
      $("[data-builder-part-suspension]").find("ul").empty();
      results.forEach((variant, index) => {
        var optionTag = variant.node.metafields.find(
          (meta) => meta?.key === "option_tag"
        )?.value;
        if (optionTag !== undefined) optionTag = JSON.parse(optionTag);

        let description = variant.node.metafields.find((meta) => meta?.key === "option_description")?.value;
        if (description == undefined) description = null;

        var isAvaialable = variant.node.metafields.find(
          (meta) => meta?.key === "option_available"
        )?.value;

        // Tracking preselected parts
        if (index === 0) {
          preselectedOptions['Suspension'] = getVariantID(variant.node.id);
          parts['Suspension'] = variant.node.title

          // Add active section price
          $("[data-builder-part-suspension]").attr('data-active-price', variant.node.price.amount === "0.0" ? '$0' : variant.node.price.amount);
        }

        $("[data-builder-part-suspension]").find("ul").append(`
          <li data-description="${description}" data-product-title="${variant.node.title}" data-featured-image="${variant.node.image.url}" data-price="${variant.node.price.amount === "0.0" ? "$0" : formatMoney(variant.node.price.amount)}" data-price-discount="${variant.node.compareAtPrice === null ? null: formatMoney(variant.node.compareAtPrice?.amount)}" data-variant-id="${variant.node.id}" data-variant-price="${variant.node.price?.amount}" data-available="${isAvaialable !== undefined ? "0" : "1"}">
            <a href="#!">
              <div class="product-option-parts-inner-container ${!variant.node.image?.url && 'no-image'} ${optionTag !== undefined && "part-tags"} ${isAvaialable !== undefined && "events-none"} ${index === 0 ? 'active': ''}">
                <div class="product-option-part-tags ${(optionTag === undefined && variant.node.compareAtPrice === null) && "hidden"}">
                  <span class="${variant.node.compareAtPrice === null && "hidden"}" style="background-color: #AC0000;">Sale</span>
                  <span class="${optionTag === undefined && "hidden"}" style="background-color: ${optionTag?.color}">${optionTag?.tag}</span>
                </div>
                <div class="parts-image-container ${!variant.node.image?.url && 'hidden'}">
                  <img class="${isAvaialable !== undefined && "not-available"}" src="${variant.node.image?.url}" alt="Wheel">
                </div>
                <div class="parts-details-container">
                  <h5>${isAvaialable !== undefined ? "No Pedals" : variant.node.title}</h5>
                  <span class="parts-price">${isAvaialable !== undefined || variant.node.price?.amount == "0.0" ? "Included" : "+ " + formatMoney(variant.node.price.amount)}</span>
                  <span class="parts-price-discount ${variant.node.compareAtPrice === null && "hidden"}">${formatMoney(variant.node.compareAtPrice?.amount)}</span>
                </div>
              </div>
            </a>
          </li>
        `);
      });
    }).catch((error) => {
      // console.log("Error: ", error);
      $("[data-builder-part-suspension]").find('ul').empty();
    });
  } else {
    $("[data-builder-part-suspension]").closest('.product-option-item').addClass('hidden');
    $("[data-builder-part-suspension]").find('ul').empty();
  }
}

const buildAssemblyKit = (handle, product = null) => {
  if (handle !== null && handle !== "n/a" && handle !== "n-a" && handle !== "" && handle.length !== 0 && handle !== undefined) {
    console.log("Assembly Kit was build");
    getBikeOptions(handle).then((results) => {
      // set assembly kit note
      if (product != null) {
        let assemblyKitNote = product.metafields.find((meta) => meta?.key === "assembly_kit_note")?.value;
        if (assemblyKitNote) {
          $('[data-builder-part-assembly-kit-header]').find('p').remove();
          $('[data-builder-part-assembly-kit-header]').append(`${assemblyKitNote}`)
        }
      }

      $("[data-builder-part-assembly-kit]").closest('.product-option-item').removeClass('hidden').removeClass('disabled');
      $("[data-builder-part-assembly-kit]").find("ul").empty();
      results.forEach((variant, index) => {
        var optionTag = variant.node.metafields.find(
          (meta) => meta?.key === "option_tag"
        )?.value;
        if (optionTag !== undefined) optionTag = JSON.parse(optionTag);

        let description = variant.node.metafields.find((meta) => meta?.key === "option_description")?.value;
        if (description == undefined) description = null;

        var isAvaialable = variant.node.metafields.find(
          (meta) => meta?.key === "option_available"
        )?.value;

        // Tracking preselected parts
        if (index === 0) {
          preselectedOptions['Assembly Kit'] = getVariantID(variant.node.id);
          parts['Assembly Kit'] = variant.node.title

          // Add active section price
          $("[data-builder-part-assembly-kit]").attr('data-active-price', variant.node.price.amount === "0.0" ? '$0' : variant.node.price.amount);
        }
        
        $("[data-builder-part-assembly-kit]").find("ul").append(`
          <li data-description="${description}" data-product-title="${variant.node.title}" data-featured-image="${variant.node.image.url}" data-price="${variant.node.price.amount === "0.0" ? "$0" : formatMoney(variant.node.price.amount)}" data-price-discount="${variant.node.compareAtPrice === null ? null: formatMoney(variant.node.compareAtPrice?.amount)}" data-variant-id="${variant.node.id}" data-variant-price="${variant.node.price?.amount}" data-available="${isAvaialable !== undefined ? "0" : "1"}">
            <a href="#!">
              <div class="product-option-parts-inner-container ${!variant.node.image?.url && 'no-image'} ${optionTag !== undefined && "part-tags"} ${isAvaialable !== undefined && "events-none"} ${index === 0 ? 'active': ''}">
                <div class="product-option-part-tags ${(optionTag === undefined && variant.node.compareAtPrice === null) && "hidden"}">
                  <span class="${variant.node.compareAtPrice === null && "hidden"}" style="background-color: #AC0000;">Sale</span>
                  <span class="${optionTag === undefined && "hidden"}" style="background-color: ${optionTag?.color}">${optionTag?.tag}</span>
                </div>
                <div class="parts-image-container ${!variant.node.image?.url && 'hidden'}">
                  <img class="${isAvaialable !== undefined && "not-available"}" src="${variant.node.image?.url}" alt="Wheel">
                </div>
                <div class="parts-details-container">
                  <h5>${isAvaialable !== undefined ? "No Pedals" : variant.node.title}</h5>
                  <span class="parts-price">${isAvaialable !== undefined || variant.node.price?.amount == "0.0" ? "Included" : "+ " + formatMoney(variant.node.price.amount)}</span>
                  <span class="parts-price-discount ${variant.node.compareAtPrice === null && "hidden"}">${formatMoney(variant.node.compareAtPrice?.amount)}</span>
                </div>
              </div>
            </a>
          </li>
        `);
      });
    }).catch((error) => {
      // console.log("Error: ", error);
      $("[data-builder-part-assembly-kit]").find('ul').empty();
    });
  } else {
    $("[data-builder-part-assembly-kit]").closest('.product-option-item').addClass('hidden');
    $("[data-builder-part-assembly-kit]").find('ul').empty();
  }
}

// const buildCarouselImage = (images) => {
//   $carouselImage = $('.slick-slider');
//   if ($carouselImage.length != 0) {
//     let minHeight = $('.product-image-container').css("height");
//     $('.product-image-container').css({"min-height": minHeight});

//     setTimeout(() => {
//       $('.product-image-container').css({"min-height": "unset"});
//     }, 1000);
//   }

//   let template_image_carousel = `<div>`
//   images.forEach((image) => {
//     const carousel_image = element.image
//   })
// }

const buildAccessories = (handle) => { 
  if (handle !== null && handle !== "n/a" && handle !== "n-a" && handle !== "" && handle.length !== 0 && handle !== undefined) {
    console.log('building accessories...');
    getBikeOptions(handle).then((results) => {
      $("[data-builder-part-accessories]").closest('.product-option-item').removeClass('hidden').removeClass('disabled');
      $("[data-builder-part-accessories]").find("ul").empty();
      results.forEach((variant, index) => { 

        console.log('accessories results: ', variant)
        var optionTag = variant.node.metafields.find(
          (meta) => meta?.key === "option_tag"
        )?.value;
        if (optionTag !== undefined) optionTag = JSON.parse(optionTag);

        let description = variant.node.metafields.find((meta) => meta?.key === "option_description")?.value;
        if (description == undefined) description = null;

        var isAvaialable = variant.node.metafields.find(
          (meta) => meta?.key === "option_available"
        )?.value;
        if(index === 0) {
          // set active price
          $("[data-builder-part-accessories]").attr('data-active-price', variant.node.price.amount === "0.0" ? '$0' : variant.node.price.amount);
        }
        $("[data-builder-part-accessories]").find("ul").append(`
          <li data-description="${description}" data-product-title="${variant.node.title}" data-featured-image="${variant.node.image.url}" data-price="${variant.node.price.amount === "0.0" ? $0 : formatMoney(variant.node.price.amount)}" data-price-discount="${variant.node.compareAtPrice === null ? null: formatMoney(variant.node.compareAtPrice?.amount)}" data-variant-id="${variant.node.id}" data-variant-price="${variant.node.price?.amount}" data-available="${isAvaialable !== undefined ? "0" : "1"}">
            <a href="#!">
              <div class="product-option-parts-inner-container ${!variant.node.image?.url && 'no-image'} ${optionTag !== undefined && "part-tags"} ${isAvaialable !== undefined && "events-none"}">
                <div class="product-option-part-tags ${(optionTag === undefined && variant.node.compareAtPrice === null) && "hidden"}">
                  <span class="${variant.node.compareAtPrice === null && "hidden"}" style="background-color: #AC0000;">Sale</span>
                  <span class="${optionTag === undefined && "hidden"}" style="background-color: ${optionTag?.color}">${optionTag?.tag}</span>
                </div>
                <div class="parts-image-container ${!variant.node.image?.url && 'hidden'}">
                  <img class="${isAvaialable !== undefined && "not-available"}" src="${variant.node.image?.url}" alt="Wheel">
                </div>
                <div class="parts-details-container">
                  <h5>${isAvaialable !== undefined ? "No Pedals" : variant.node.title}</h5>
                  <span class="parts-price">${isAvaialable !== undefined || variant.node.price?.amount == "0.0" ? "Included" : formatMoney(variant.node.price.amount)}</span>
                  <span class="parts-price-discount ${variant.node.compareAtPrice === null && "hidden"}">${formatMoney(variant.node.compareAtPrice?.amount)}</span>
                </div>
              </div>
            </a>
          </li>
        `);
      });
    }).catch((error) => {
      // console.log("Error: ", error);
      $("[data-builder-part-accessories]").find('ul').empty();
    });
  } else {
    $("[data-builder-part-accessories]").closest('.product-option-item').addClass('hidden');
    $("[data-builder-part-accessories]").find('ul').empty();
  }
}

// Reset bike builder options
const resetBuilder = () => {
  // reset preselected options
  preselectedOptions = {};
  parts = {};
  // Loop through all product-option-item except the first one
  let totalOptionItem = $(".product-option-item").length;
  $(".product-option-item").each(function (index) {
    if (index !== 0) {
      if (index !== totalOptionItem - 1) {
        // $(this).addClass("disabled");
      } else {
        $(this).find('.product-summary-container').addClass('disabled');
      }

      // find divs and remove active class
      $(this).find("div").removeClass("active").find('a').removeClass('active');
      $(this).find("div").removeClass("active").find('a').removeClass('active');

      // remove active class from all the buttons
      $(this).find("button").removeClass("active");

      // Reset the bike wheelset and pedals
      $('#bike-wheelset').val('n/a');
      $('#bike-drivetrain').val('n/a');
      $('#bike-cycling-computer').val('n/a');
      $('#bike-pedals').val('n/a');
      $('#bike-package').val('n/a');
      $('#bike-seatpost').val('n/a');
      $('#bike-suspension-travel').val('n/a');
      $('#bike-suspension').val('n/a');
      $('#bike-flat-protection').val('n/a');
      $('#bike-frame-protection').val('n/a');
      $('#bike-battery').val('n/a');
      $('#bike-handlebar').val('n/a');
      $('#bike-assembly-kit').val('n/a');

      // Hides size options
      $('[data-builder-sizing-options]').closest('.product-option-item').addClass('hidden');

      // Reset the bike variant color and size
      $('#bike-variant-color').val('n/a');
      $('#bike-variant-size').val('n/a');

      $('.color-option').find('span').removeClass('slide-up');

      // check if this has [data-option-build] data attr and add customize class
      if ($(this).filter("[data-option-build]").length > 0) {
        $(this).addClass("customize");
      }

      // check if this has [data-option-package] data attr and add customize class
      if ($(this).filter("[data-option-package]").length > 0) {
        $(this).addClass("package");
      }

    }
  });
}

// remove disabled class from product option item
const removeDisabledClass = ($context, onScroll = true, offset) => {
  // loop through all .product-option-item next check if it is not empty if it is then proceed to the next until it is not empty then remove disabled class
  $context.closest(".product-option-item").nextAll().each(function () {
    if ($(this).is(":empty") || $(this).hasClass("package") || $(this).hasClass("hidden")) {
      $(this).addClass("disabled");
    } else {
      $(this).removeClass("disabled");
      $(this).find('.product-summary-container').removeClass('disabled');
      if ($(this).find('[data-builder-part-accessories]').length > 0) {
        $('.product-summary-container').removeClass('disabled');
      }
      if (onScroll) scrollToTarget($(this), offset);
      return false;
    }
  });
}

// Build build specs and FAQ
const buildFAQSpecs = (FAQ, buildSpecs, title, variants) => {
  const jsonData = JSON.parse(FAQ);
  const data = JSON.parse(buildSpecs)

  // selecting containers
  const faqTabs = document.querySelector('.qa-buttons');
  const faqContent = document.querySelector('.qa-container-outer');
  
  // Iterate through each tab
  jsonData.tabs.forEach(tab => {
    // Create tab button
    const tabButton = document.createElement('button');
    tabButton.textContent = tab.parent;
    tabButton.classList.add('faq-tab-button');
    faqTabs.appendChild(tabButton);

    // Create tab content container
    const tabContent = document.createElement('div');
    tabContent.classList.add('tab-content');
    faqContent.appendChild(tabContent);
   var sum = 0;
    // Iterate through each FAQ item in the tab
    const faqItemLeft = document.createElement('div');
      faqItemLeft.classList.add('qa-container-left');
      const faqItemRight = document.createElement('div');
      faqItemRight.classList.add('qa-container-right');

    tab.items.forEach((item, index) => {
      if((sum += 1) % 2 == 0){
      const question = document.createElement('div');
      question.innerHTML = `<div class="container">
          <h2>${item.question}</h2>
      </div>
      
      <div class="answers-container">
          <p>${item.answer}</p>
      </div>`;
      const faqItem = document.createElement('div');
      faqItem.classList.add('qa-container');
      faqItem.appendChild(question);
      faqItemLeft.appendChild(faqItem);
      tabContent.appendChild(faqItemLeft);
      } else {
          const question = document.createElement('div');
      question.innerHTML = `<div class="container">
          <h2>${item.question}</h2>
      </div>
      
      <div class="answers-container">
          <p>${item.answer}</p>
      </div>`;
      const faqItem = document.createElement('div');
      faqItem.classList.add('qa-container');
      faqItem.appendChild(question);
      faqItemRight.appendChild(faqItem);
      tabContent.appendChild(faqItemRight);
      }
    });

    // Add event listener to toggle tab content visibility
    tabButton.addEventListener('click', () => {
      document.querySelectorAll('.qa-buttons button').forEach(table => {
        table.classList.remove("active");
      });
      tabButton.classList.add("active");
      
      
      faqContent.querySelectorAll('.tab-content').forEach(content => {
        content.classList.remove("active");
      });
      tabContent.classList.add("active");
    });

    $('.qa-buttons button:first-child').click();
  });

  if( $(".qa-container .container").hasClass('active') ){
    $(".qa-container .container.active").closest('.qa-container').find('.answers-container').show();
  }
  $(".qa-container .container").click(function(){
    if( $(this).hasClass('active') ){
      $(this).removeClass("active").closest('.qa-container').find('.answers-container').slideUp(500);
    }
    else{	$(this).addClass("active").closest('.qa-container').find('.answers-container').slideDown(500);
    }
  });

  $(".pdp-build-specs-heading a, .btn-nav-buildspecs, [data-build-specs], [data-spec-sheet]").click(function(e){
    e.preventDefault();
    $("#pdp-build-specs-overlay").fadeIn();
    $("html").addClass("disable-scroll");
    if($("#bikeTable tbody tr").length == 0){
    
      const tableHeader = document.querySelector('#bikeTable thead');
      const tableBody = document.querySelector('#bikeTable tbody');

      // Populate table header
      const builds = data.map(bike => bike.build);
      builds.forEach(build => {
        const row = document.createElement('tr');
        const header = document.createElement('th');
        header.textContent = build;
        tableHeader.appendChild(header);
      });

      // Populate table body
      const properties = Object.keys(data[0]).filter(property => property !== 'build');
      properties.forEach(property => {
        // console.log(property);
        const row = document.createElement('tr');
        data.forEach((bike, index) => {
          const cell = document.createElement('td');
          if (property.toLowerCase() === 'price') {
            cell.innerHTML = `<p class="build-name">${property}</p><p class="build-value">${formatMoney(variants[index].node.price.amount)}</p><p class="${variants[index].node.compareAtPrice?.amount ? '': 'hidden'}" style="text-decoration: line-through; margin-top: -22px;">${formatMoney(variants[index].node.compareAtPrice?.amount)}</p>`;
          } else {
            cell.innerHTML = `<p class="build-name">${property}</p><p class="build-value">${bike[property]}</p>`;

          }
          row.appendChild(cell);
        });
        tableBody.appendChild(row);
      });
    }

  });

  $("#closeButton").click(function(){
    $("html").removeClass("disable-scroll");
      $("#pdp-build-specs-overlay").fadeOut();
  });

  // Build Table
  const testDiv = document.querySelector('.pdp-build-test');
  data.forEach((item, index) => {
    const table = document.createElement('div');
    table.className="build-specs-table";
    table.innerHTML = `
        <h5 class="build-specs-heading">
          Specifications
        </h5>
      <div class="build-specs-table-inner">
        ${Object.entries(item).map(([key, value]) => {
          if (key.toLowerCase() === 'price') {
            return `
            <div style="border: 1px solid #656565; padding: 20px;"><p class="build-name">${key}</p><p class="build-value">${formatMoney(variants[index].node.price.amount)}</p><p class="${variants[index].node.compareAtPrice?.amount ? '': 'hidden'}" style="text-decoration: line-through; margin-top: -22px; color: #ffffff;">${formatMoney(variants[index].node.compareAtPrice?.amount)}</p></div>
        `
          }
          return `
            <div style="border: 1px solid #656565; padding: 20px;"><p class="build-name">${key}</p><p class="build-value">${value}</p></div>
        `
        }).join('')}
      </div>
    `;

    testDiv.appendChild(table);
  });

  // Build buttons
  const buttonsDiv = document.querySelector('.pdp-build-specs-buttons');

  data.forEach((item, index) => {
    const button = document.createElement('button');
    button.innerHTML = `<span>${title} ${item.build}</span>`;
    button.addEventListener('click', () => {
      document.querySelectorAll('.pdp-build-specs-buttons button').forEach(table => {
        table.classList.remove("active");
      });
      button.classList.add("active");
      
      document.querySelectorAll('.build-specs-table').forEach(table => {
        table.style.display = 'none';
      });
      document.querySelectorAll('.build-specs-table')[index].style.display = 'block';
    });
    buttonsDiv.appendChild(button);
  });

  $(".pdp-build-specs-buttons button:first-child").click();
}

// document ready
document.addEventListener("DOMContentLoaded", function () {
  // Make sure the bike builder options are on top
  scrollToTarget($(".bike-builder-container"));
  // clear cart on load
  clearCart();

  // All bike build variants
  var variantsArr = [];

  var product = null;

  var variants = null;

  var selectedVariant = null;

  // META FIELDS
  var variantMeta = `[
    {
      namespace: "bike_builder",
      key: "estimated_delivery"
    },
    {
      namespace: "bike_builder",
      key: "variant_colors"
    },
    {
      namespace: "bike_builder",
      key: "carousel_images"
    },
    {
      namespace: "bike_builder",
      key: "sale_campaign"
    },
    {
      namespace: "bike_builder",
      key: "variant_sizes"
    },
    {
      namespace: "bike_builder",
      key: "bike_option_wheelsets"
    },
    {
      namespace: "bike_builder",
      key: "bike_option_drivetrain"
    },
    {
      namespace: "bike_builder",
      key: "bike_option_pedals"
    },
    {
      namespace: "bike_builder",
      key: "bike_option_package"
    },
    {
      namespace: "bike_builder",
      key: "bike_option_seatpost"
    },
    {
      namespace: "bike_builder",
      key: "bike_option_suspension_travel"
    },
    {
      namespace: "bike_builder",
      key: "bike_option_suspension"
    },
    {
      namespace: "bike_builder",
      key: "bike_option_flat_protection"
    },
    {
      namespace: "bike_builder",
      key: "bike_option_frame_protection"
    },
    {
      namespace: "bike_builder",
      key: "bike_option_battery"
    },
    {
      namespace: "bike_builder",
      key: "bike_option_handlebar"
    },
    {
      namespace: "bike_builder",
      key: "bike_option_cycling_computer"
    },
    {
      namespace: "bike_builder",
      key: "bike_option_accessories"
    },
    {
      namespace: "bike_builder",
      key: "bike_option_assembly_kit"
    },
    {
      namespace: "bike_builder",
      key: "bike_parts"
    },
    {
      namespace: "bike_builder",
      key: "wheelset_images"
    },
    {
      namespace: "bike_builder",
      key: "variant_drop_link"
    },
    {
      namespace: "bike_builder",
      key: "is_hidden_on_builder"
    },
    {
      namespace: "bike_builder",
      key: "battery_option"
    }
  ]`;

  var productMeta = `[
    {
      namespace: "bike_builder",
      key: "carousel_images"
    },
    {
      namespace: "bike_builder",
      key: "sizing_guide"
    },
    {
      namespace: "bike_builder",
      key: "sizing_guide_image"
    },
    {
      namespace: "bike_builder",
      key: "assembly_kit_note"
    },
    {
      namespace: "product",
      key: "faq_section"
    },
    {
      namespace: "table",
      key: "build_specs"
    }
  ]`;

  // Query Options
  var productQuery = `{
    product(handle: "${bikeParam}") {
      id
      title
      handle
      description
      variants(first: 16) {
          edges {
              node {
                  id
                  price {
                      amount
                  }
                  title
                  image {
                      url
                  }
                  barcode
                  quantityAvailable
                  metafields(identifiers: ${variantMeta}) {
                    key
                    value
                  }
                  availableForSale
                  compareAtPrice {
                    amount
                  }
              }
          }
      }
      images(first: 1) {
          edges {
              node {
                  url
                  altText
              }
          }
      }
      metafields(identifiers: ${productMeta}) {
        key
        value
      }
    }
  }`;

  // Fetch the product data
  $.ajax({
    type: "POST",
    url: apiURL,
    headers: {
      "X-Shopify-Storefront-Access-Token": token,
      "content-Type": "application/graphql",
    },
    data: productQuery,
    success: (results) => {
      console.log('results: ', results);
      product = results.data.product;
      variants = product.variants.edges;

      // console.log("Product: ", product);
      console.log("Variants: ", variants);
      console.log("Product: ", product);

      let faq = product.metafields.find((meta) => meta?.key === "faq_section")?.value;
      let buildSpecs = product.metafields.find((meta) => meta?.key === "build_specs")?.value;
      buildFAQSpecs(faq, buildSpecs, product.title, variants);

      // Remove top options loading skeleton
      $("[data-builder-top-options]").find("a").removeClass("loading-skeleton");

      // Set the product title
      $("[data-builder-product-title]")
        .find(".product-title h2")
        .text(product.title);

      $("[data-builder-product-title]")
        .find(".product-title")
        .removeClass("loading-skeleton");

      // Set the product price
      $("[data-builder-product-title")
        .find(".product-price span")
        .text(formatMoney(variants[0].node.price.amount));
      $("[data-builder-product-title")
        .find(".product-price")
        .removeClass("loading-skeleton");

      // Set product sizing image
      let sizingGuideImageURL = product.metafields.find((meta) => meta?.key === "sizing_guide_image")?.value;
      if (sizingGuideImageURL) $('[data-sizing-image]').find('img').attr('src', sizingGuideImageURL);

      // Set the product variants
      // clear all item list
      $("[data-builder-option-variants]").find("ul").empty();
      variants.forEach((variant, variantIndex) => {
        console.log('variant rending....', variant)
        let saleCampaign = variant.node.metafields.find(
          (meta) => meta?.key === "sale_campaign"
        )?.value;
        // Bike option sets
        let wheelset = variant.node.metafields.find((meta) => meta?.key === "bike_option_wheelsets")?.value || null;
        let drivetrain = variant.node.metafields.find((meta) => meta?.key === "bike_option_drivetrain")?.value || null;
        let cyclingComputer = variant.node.metafields.find((meta) => meta?.key === "bike_option_cycling_computer")?.value || null;
        let pedals = variant.node.metafields.find((meta) => meta?.key === "bike_option_pedals")?.value || null;
        let seatpost = variant.node.metafields.find((meta) => meta?.key === "bike_option_seatpost")?.value || null;
        let suspensionTravel = variant.node.metafields.find((meta) => meta?.key === "bike_option_suspension_travel")?.value || null;
        let suspension = variant.node.metafields.find((meta) => meta?.key === "bike_option_suspension")?.value || null;
        let flatProtection = variant.node.metafields.find((meta) => meta?.key === "bike_option_flat_protection")?.value || null;
        let frameProtection = variant.node.metafields.find((meta) => meta?.key === "bike_option_frame_protection")?.value || null;
        let battery = variant.node.metafields.find((meta) => meta?.key === "bike_option_battery")?.value || null;
        let handlebar = variant.node.metafields.find((meta) => meta?.key === "bike_option_handlebar")?.value || null;
        let assemblyKit = variant.node.metafields.find((meta) => meta?.key === "bike_option_assembly_kit")?.value || null;
        let accessories = variant.node.metafields.find((meta) => meta?.key === "bike_option_accessories")?.value || null;
        let colors = variant.node.metafields.find((meta) => meta?.key === "variant_colors")?.value || null;
        let sizing = variant.node.metafields.find((meta) => meta?.key === "variant_sizes")?.value || null;
        let bikeParts = variant.node.metafields.find((meta) => meta?.key === "bike_parts")?.value || null;
        let variantDropLink = variant.node.metafields.find((meta) => meta?.key === "variant_drop_link")?.value || null;
        let carouselImages = variant.node.metafields.find((meta) => meta?.key === "carousel_images")?.value || null;
        let wheelsetImages = variant.node.metafields.find((meta) => meta?.key === "wheelset_images")?.value || null;
        let isHiddenOnBuilder = variant.node.metafields.find((meta) => meta?.key === "is_hidden_on_builder")?.value || null;
        let batteryOption = variant.node.metafields.find((meta) => meta?.key === "battery_option")?.value || "[]";

        batteryOption = JSON.parse(batteryOption);
        
        let batteryOptionTemplate = ``;
        if (batteryOption.length > 0) {
          let batteryItems = ``;
          batteryOption.forEach((battery, index) => {
            let batteryTag = ``;

            if (battery.tag) {
              batteryTag = `<span class="battery-tag">${battery.tag}</span>`;
            }

            batteryItems += `
            <div class="battery-item-container">
            <input type="radio" value="${battery.battery_id}" name="battery option ${variantIndex}" id="${battery.battery_id}" ${index === 0 ? 'checked': ''}/>
            <label for="${battery.battery_id}" class="product-item-battery-option">
              <span>${battery.title}</span>
              ${batteryTag}
            </label>
            </div>
          `;
          });

          batteryOptionTemplate = `
          <div class="battery-container hidden">
            <h4 class="battery-heading">Choose your battery:</h4>
            <p class="battery-builder-note">Changing the included battery will reset bike builder.</p>
            ${batteryItems}
          </div>`;
        }

        let bikePartsContent = `
        <span class="product-part-title">Demo DVO ONYX D1 SC29</span> 
        <span class="product-part-title">Demo Shimano SLX 12-Speed</span>
        <span class="product-part-title">Demo Stans Flow S2</span>
        <span class="product-part-title">Demo SRAM CODE R</span>
        `;
        if (bikeParts) {
          bikePartsContent = "";
          JSON.parse(bikeParts).forEach((part) => {
            bikePartsContent += `<span>${part}</span>`;
          });
        }

        saleCampaign = saleCampaign ? JSON.parse(saleCampaign) : null;
        $("[data-builder-option-variants]").find("ul").append(`
          <li class="${isHiddenOnBuilder == 'true' ? 'hidden':''}" data-variant-id="${variant.node.id}" 
          data-variant-price="${variant.node.price.amount}" 
          data-bike-wheelset="${wheelset || 'n/a'}" 
          data-bike-drivetrain="${drivetrain || 'n/a'}" 
          data-bike-cycling-computer="${cyclingComputer || 'n/a'}" 
          data-bike-pedals="${pedals || 'n/a'}"
          data-bike-seatpost="${seatpost || 'n/a'}"
          data-bike-suspension-travel="${suspensionTravel || 'n/a'}"
          data-bike-suspension="${suspension || 'n/a'}"
          data-bike-flat-protection="${flatProtection || 'n/a'}"
          data-bike-frame-protection="${frameProtection || 'n/a'}"
          data-bike-battery="${battery || 'n/a'}"
          data-bike-handlebar="${handlebar || 'n/a'}"
          data-bike-assembly-kit="${assemblyKit || 'n/a'}"
          data-bike-accessories="${accessories || 'n/a'}"
          data-bike-variant-colors='${colors || 'n/a'}'
          data-bike-sizing='${sizing || 'n/a'}'
          data-bike-wheelset-colors='${wheelsetImages || 'n/a'}'
          data-bike-carousel-images='${carouselImages || 'n/a'}'
          data-variant-title="${variant.node.title}"
          data-available="1">
            <div class="product-item-container">
              <div class="product-item-inner-container expanded">
                <div class="product-item-tags">
                  <span class="${!(Number(variant.node.quantityAvailable) <= 10) && 'hidden'}" style="background-color: black">Only ${variant.node.quantityAvailable} left</span>
                  <span class="${!(saleCampaign && saleCampaign[0]?.title) && 'hidden'}" style="background-color: ${saleCampaign && saleCampaign[0]?.color}">${saleCampaign && saleCampaign[0]?.title}</span>
                  <span class="${!(saleCampaign && saleCampaign[1]?.title) && 'hidden'}" style="background-color: ${saleCampaign && saleCampaign[1]?.color}">${saleCampaign && saleCampaign[1]?.title}</span>
                  <span class="${!(saleCampaign && saleCampaign[2]?.title) && 'hidden'}" style="background-color: ${saleCampaign && saleCampaign[2]?.color}">${saleCampaign && saleCampaign[2]?.title}</span>
                </div>
                <div class="product-item-details-container">
                  <div class="product-item-details-inner-container">
                    <div class="product-item--title">
                      <h3 class="product-title">${variant.node.title}</h3>
                    </div>
                    <div class="product-item--prices">
                      <span class="product-price">${formatMoney(variant.node.price.amount)}</span>
                      <span class="product-orginal-price ${variant.node.compareAtPrice?.amount ? "" : "hidden"}">${formatMoney(variant.node.compareAtPrice?.amount)}</span>
                      <span class="product-discounts ${variant.node.compareAtPrice?.amount ? "" : "hidden"}">Save $${Number(variant.node.compareAtPrice?.amount) - Number(variant.node.price?.amount)}</span>
                    </div>
                  </div>
                  <div class="product-item-includes ${variant.node.compareAtPrice?.amount ? "" : "spacing"}">
                    ${bikePartsContent}
                  </div>
                  ${batteryOptionTemplate}
                </div>
              </div>
              <a class="product-item-action" href="#!"></a>
            </div>
            <div class="product-card-link-container ${!JSON.parse(variantDropLink)?.enabled ? "hidden" : ""}">
              <div class="product-card-link-inner-container">
                <h3>${JSON.parse(variantDropLink)?.title}</h3>
                <span>${JSON.parse(variantDropLink)?.description}</span>
              </div>
              <a data-link="${JSON.parse(variantDropLink)?.url}" href="${JSON.parse(variantDropLink)?.url}" class="product-card-link"></a>
            </div>
          </li>
         `);
       });

       // Set the product image carousels
      // get product carousel images
      let productCarouselImages = variants[0].node.metafields.find((meta) => meta?.key === "carousel_images")?.value || "[]";
      if (productCarouselImages.length !== 0) {
        imageCarousel(product, productCarouselImages);
      }

      // Set variant colors
      let defaultVariantColors = variants[0].node.metafields.find((meta) => meta?.key === "variant_colors")?.value || "[]"
      buildVariantColors(JSON.parse(defaultVariantColors));

      // Set Sizing Guide
      // let sizingGuide = JSON.parse(product.metafields.find((meta) => meta.key === "sizing_guide").value);
      // buildVariantSizes(sizingGuide);

      // Set Bike Option Package
      let bikeOptionPackage = variants[0].node.metafields.find((meta) => meta?.key === "bike_option_package")?.value || null;
      $('[data-builder-package-options]').find('.product-detail-action').empty();
      $('[data-builder-package-options]').find('.product-detail-action').append(`
        <button data-package="${bikeOptionPackage}" data-build="package">Packages</button> 
        <button data-build="customize">Customize</button>
      `);

      // REBUILD THE BIKE BUILDER OPTIONS

      // Set Bike Option Wheelsets
      let bikeOptionWheelsets = variants[0].node.metafields.find((meta) => meta?.key === "bike_option_wheelsets")?.value || null;
      buildWheelset(bikeOptionWheelsets);

      // Set Bike Option Drivetrain
      let bikeOptionDrivetrain = variants[0].node.metafields.find((meta) => meta?.key === "bike_option_drivetrain")?.value || null;
      buildDrivetrain(bikeOptionDrivetrain);

      // Set Bike Option Drivetrain
      let bikeOptionCyclingComputer = variants[0].node.metafields.find((meta) => meta?.key === "bike_option_cycling_computer")?.value || null;
      buildCyclingComputer(bikeOptionCyclingComputer);

      // Set Bike Option Pedals
      let bikeOptionsPedals = variants[0].node.metafields.find((meta) => meta?.key === "bike_option_pedals")?.value || null;
      buildPedals(bikeOptionsPedals);

      // Set Bike Option Seatpost
      let bikeOptionSeatpost = variants[0].node.metafields.find((meta) => meta?.key === "bike_option_seatpost")?.value || null;
      buildSeatpost(bikeOptionSeatpost);

      // Set Bike Option Suspension Travel
      let bikeOptionSuspensionTravel = variants[0].node.metafields.find((meta) => meta?.key === "bike_option_suspension_travel")?.value || null;
      buildSuspensionTravel(bikeOptionSuspensionTravel);

      // Set Bike Option Suspension
      let bikeOptionSuspension = variants[0].node.metafields.find((meta) => meta?.key === "bike_option_suspension")?.value || null;
      buildSuspension(bikeOptionSuspension);

      // Set Bike Option Flat Protection
      let bikeOptionFlatProtection = variants[0].node.metafields.find((meta) => meta?.key === "bike_option_flat_protection")?.value || null;
      buildFlatProtection(bikeOptionFlatProtection);

      // Set Bike Option Frame Protection
      let bikeOptionFrameProtection = variants[0].node.metafields.find((meta) => meta?.key === "bike_option_frame_protection")?.value || null;
      buildFrameProtection(bikeOptionFrameProtection);

      // Set Bike Option Frame Protection
      let bikeOptionBattery = variants[0].node.metafields.find((meta) => meta?.key === "bike_option_battery")?.value || null;
      buildBattery(bikeOptionBattery);

      // Set Bike Option Frame Protection
      let bikeOptionHandlebar = variants[0].node.metafields.find((meta) => meta?.key === "bike_option_handlebar")?.value || null;
      buildHandlebar(bikeOptionHandlebar); 

      // Set Bike Option Assembly Kit
      let bikeOptionAssemblyKit = variants[0].node.metafields.find((meta) => meta?.key === "bike_option_assembly_kit")?.value || null;
      buildAssemblyKit(bikeOptionAssemblyKit, product);

      // Set Bike Option Accessories
      let bikeOptionAccessories = variants[0].node.metafields.find((meta) => meta?.key === "bike_option_accessories")?.value || null;
      buildAccessories(bikeOptionAccessories);

      $("[data-builder-option-variants]")
        .find("ul")
        .children()
        .each(function () {
          let $builderOptionContext = $(this);
          $(this).on("click", "a", async function (e) {
            // let variantId = getVariantID($builderOptionContext.data("variant-id"));
            // variantsArr.push(variantId);
            let isAvailable = Number($builderOptionContext.data("available"));

            if (isAvailable === 0) return;

            // check if this element has data-link attribute if it does navigate to the link
            const link = $(this).attr('data-link');
            if (link) {
              window.location.href = link;
            }
            
            e.preventDefault();
            
            // check if this is already active
            if ($(this).hasClass("active")) return;

            // Set image to loading
            $(".product-image-container").addClass("loading-skeleton");

            //  Check first if this option is already active
            if ($(this).hasClass("active")) return;

            // Reset builder
            resetBuilder();

            // lock all buttons
            disabledAllButtons($(this));

            // clear cart
            await clearCart();

            // add this variant to cart
            selectedVariantID = getVariantID($(this).closest("li").data("variant-id"));

            // add to cart
            await addToCart(selectedVariantID);

            $('#bike-variant-color-image').val($(this).closest("li").data("bike-carousel-images")[0].image);
            
            // add this variant image to carousel
            imageCarousel(product, $(this).closest("li").data("bike-carousel-images"));

            // unlock all buttons
            unlockingAllButtons($(this));
            
            // Remove active class from all the options
            $("[data-builder-option-variants]")
              .find("a")
              .removeClass("active");

            $("[data-builder-option-variants]")
            .find(".product-item-container").removeClass("active");

            $("[data-builder-option-variants]").find(".battery-container").addClass("hidden");

            // $("[data-builder-option-variants]")
            // .find(".product-item-inner-container").removeClass("expanded");

            // update price
            // bikeTotalPrice = updateProductPrice(bikeTotalPrice, Number($(this).closest("li").data("variant-price")));
            // Remove slide-up class
            $('[data-builder-product-title]').find('.product-title').find('span').removeClass('slide-up');
            $('[data-builder-product-title]').find('.header-price').removeClass('slide-up');
            const cartPrice = await updateCartTotalPrice();

            await updateBreadPayment(cartPrice);

            // Rebuild variant colors
            let colors = $(this).closest("li").data("bike-variant-colors");
            if (colors === "n/a") {
              $("[data-builder-variant-colors]").closest('.product-option-item').addClass('hidden');
              $("[data-builder-variant-colors]").find('ul').empty();
            } else {
              // build variant colors
              $("[data-builder-variant-colors]").closest('.product-option-item').removeClass('hidden');
              buildVariantColors(colors);
            }

            // Rebuild sizing -> disable this as size is attached to color
            // let sizing = $(this).closest("li").data("bike-sizing");
            // if (sizing === "n/a") {
            //   let sizingGuide = JSON.parse(product.metafields.find((meta) => meta.key === "sizing_guide").value);
            //   buildVariantSizes(sizingGuide);
            // } else {
            //   // build sizing
            //   buildVariantSizes(sizing);
            // }

            // Rebuild wheelset
            let wheelset = $(this).closest("li").data("bike-wheelset");
            let wheelsetImages = $(this).closest("li").data("bike-wheelset-colors");
            console.log("Wheelset Images: ", wheelsetImages);
            buildWheelset(wheelset, wheelsetImages);

            // Rebuild drivetrain
            let drivetrain = $(this).closest("li").data("bike-drivetrain");
            buildDrivetrain(drivetrain);

            // Rebuild cycling computer
            let cyclingComputer = $(this).closest("li").data("bike-cycling-computer");
            buildCyclingComputer(cyclingComputer);

            // Rebuild pedals
            let pedals = $(this).closest("li").data("bike-pedals");
            buildPedals(pedals);

            // Rebuild seatpost
            let seatpost = $(this).closest("li").data("bike-seatpost");
            buildSeatpost(seatpost);

            // Rebuild suspension travel
            let suspensionTravel = $(this).closest("li").data("bike-suspension-travel");
            buildSuspensionTravel(suspensionTravel);

            // Rebuild suspension
            let suspension = $(this).closest("li").data("bike-suspension");
            buildSuspension(suspension);

            // Rebuild flat protection
            let flatProtection = $(this).closest("li").data("bike-flat-protection");
            buildFlatProtection(flatProtection);

            // Rebuild frame protection
            let frameProtection = $(this).closest("li").data("bike-frame-protection");
            buildFrameProtection(frameProtection);

            // Rebuild battery
            let battery = $(this).closest("li").data("bike-battery");
            buildBattery(battery);

            // Rebuild battery
            let handlebar = $(this).closest("li").data("bike-handlebar");
            buildHandlebar(handlebar);

            // Rebuild assembly kit
            let assemblyKit = $(this).closest("li").data("bike-assembly-kit");
            buildAssemblyKit(assemblyKit, product);

            //Rebuild accessories
            let accessories = $(this).closest("li").data("bike-accessories");
            buildAccessories(accessories);

            $(this).addClass("active");
            $(this).closest("li").find(".product-item-container").addClass("active")

            // move title to original position
            $('[data-builder-product-title] .product-title').css('transform', 'translateY(0)');

            // add delay on animation about .5s
            setTimeout(() => {
            // Get this variant title
            let variantTitle = $(this).closest("li").data("variant-title");
            $('[data-builder-product-title]').find('.product-title').find('span').text(variantTitle.replace(product.title, "")).addClass('slide-up');
            $('[data-builder-product-title]').find('.header-price').addClass('slide-up');
            }, 200);

            // set selected variant
            selectedVariant = $(this).closest("li").data("variant-title");
            const $context = $(this);

            // check if this has battery-container, if it does remove the hidden class
            if ($(this).closest("li").find('.battery-container').length > 0) {
              $(this).closest("li").find('.battery-container').removeClass('hidden');
            }
            // add event listener to input radio of battery-container
            $(this).closest("li").find('.battery-container').on('change', 'input[type="radio"]', async function (e) {
              if (selectedVariantID != $(this).val()) {
                console.log("Trigger changed event");
                selectedVariantID = $(this).val();
                $(this).closest('li').data('variant-id', `gid://shopify/ProductVariant/${$(this).val()}`);

                console.log("Updated variant id: ", $(this).closest('li').data("variant-id"));
                
                $(this).closest('li').find('.product-item-action').removeClass('active');
                $(this).closest('li').find('.product-item-action').trigger('click');
              }
            });

            // Remove disable class and scroll to next option if true
            removeDisabledClass($(this), false);

            //expand the product parts
            // $(this).closest('li').find('.product-item-inner-container').addClass('expanded');
          });
        });
    },
    error: (error) => {
      // console.log("App data error: ", error);
    },
  });

  $("[data-builder-variant-colors]").on("click", "a", async function (e) {
    e.preventDefault();

    // Check active wheelset
    const activeWheelset = $('[data-builder-part-wheelset]').find('.product-option-parts-inner-container.active').closest('li').data('wheel-color') || [];

    console.log("Active wheelset: ", activeWheelset);

    // Set image to loading
    $(".product-image-container").addClass("loading-skeleton");

    // remove this color selected
    $(this).closest('.product-option-item').find('.color-option').find('span').removeClass('slide-up');

    // lock all buttons
    disabledAllButtons($(this));
    

    // get carousel image
    let thisColorImage = $(this).closest("li").data("carousel-image");

    // Get the selected color
    $('#bike-variant-color').val($(this).closest("li").data("variant-color"));
    if (thisColorImage.length > 0) $('#bike-variant-color-image').val(thisColorImage[0]);
    await changeBikeProperties($('#bike-variant').val());

    // convert thisColorImage to object array
    thisColorImage = thisColorImage.map((image) => {
      return {
        image: image,
      };
    })

    // console.log("New Carousel Images: ", thisColorImage);
    if (activeWheelset && activeWheelset?.length > 0) {
      const selectedColorName = $(this).find('span').text();
      const wheelImageObj = activeWheelset.find((image) => image.color.toLowerCase() === selectedColorName.toLowerCase());

      const formattedImage = [{image: wheelImageObj.img}];
      imageCarousel(product, formattedImage);
    } else {
      imageCarousel(product, thisColorImage);
    }


    // Set Bike Sizes
    let sizes = $(this).closest("li").data("frame-size");
    if (sizes !== null && sizes !== "n/a" && sizes !== "n-a" && sizes !== "" && sizes.length !== 0 && sizes !== undefined) {
      buildVariantSizes(sizes, product.handle);
      // console.log('sizes', sizes);
    }

    // Remove active class from all the options
    $("[data-builder-variant-colors]")
      .find(".product-option-colors-inner-container")
      .removeClass("active");
    $(this).find(".product-option-colors-inner-container").addClass("active");

    // show this card color
    let selectedColor = $(this).closest("li").data("variant-color");
    $(this).closest('.product-option-item').find('.color-option').find('span').html(selectedColor).addClass('slide-up');

    // Remove disable class and scroll to next option if true
    removeDisabledClass($(this), false);

    // unlock all buttons
    unlockingAllButtons($(this));
  });

  $("[data-builder-sizing-options]").on(
    "click",
    "a",
     async function (e) {
      e.preventDefault();

      // Check first if available
      if ($(this).find('.product-option-size-inner-container').hasClass('active')) return;
      if (Number($(this).closest('li').data('available')) === 0) return;

      // lock all buttons
      disabledAllButtons($(this));

      // Get the selected size
      $('#bike-variant-size').val($(this).closest("li").data("variant-size"));
      await changeBikeProperties($('#bike-variant').val());

      // set summary est
      // $(['data-summary-est']).text($(this).closest("li").data("est"));
      $("[data-summary-est]").html(`Estimated Completion: <span>${$(this).closest("li").data("est")}</span>`)

      // Remove active class from all the options
      $("[data-builder-sizing-options]")
        .find(".product-option-size-inner-container")
        .removeClass("active");
      $(this).find(".product-option-size-inner-container").addClass("active");

      // check first if $this has a member element with an ID of custom-fit-option
      if ($(this).closest('ul').find("#custom-fit-option").length > 0) {
        //scroll to custom fit option
        // scrollToTarget($(this).closest('ul').find("#custom-fit-option"));

        
        // add click event for skip custom fit
        $(this).closest('ul').find("#custom-fit-option").on("click", "button[data-action-skip]", () => {
          // set input to skip
          $('#bike-custom-fit-skip').val('skip');

          // loop all input with id starting with bike-custom-fit and set to n/a except the skip input
          $('input[id^="bike-custom-fit"]').each(function () {
            if ($(this).attr('id') !== 'bike-custom-fit-skip') {
              $(this).val('n/a');
            }
          });

          // reset custom fit popup make all input type number value to null and remove radio button checked
          $('.fit-container').find('input[type="number"]').val(null);
          $('.fit-container').find('input[type="radio"]').prop('checked', false);

          // hide all elements with fit class on fit container except the first one
          $('.fit-container').find('.fit').each(function (index) {
            if (index !== 0) {
              $(this).addClass('hidden');
            } else {
              $(this).removeClass('hidden');
            }
          });

          // remove active class on all fit indicator except the first one
          $('.fit-indicator ul').children().each(function (index) {
            if (index !== 0) {
              $(this).removeClass('active');
            } else {
              $(this).addClass('active');
            }
          });

          // loop through all the product-option-item class and remove the customize class
          $("[data-option-build]").each(function (index) {
            $(this).removeClass("customize");
            if (index === 0) {
              $(this).removeClass("disabled");
            }
          });

          $('.product-summary-container').removeClass('disabled');
          
          $('.product-summary-container').removeClass('disabled');
          removeDisabledClass($(this), true, 90);
          //update properties on skip
          changeBikeProperties($('#bike-variant').val());
          
        });

        // check product handle if 801-dirt-jumper
        if (product.handle === '801-dirt-jumper') {
          // perform click on skip
          $(this).closest('ul').find("#custom-fit-option").find('button[data-action-skip]').click();
        }
      } else {
        // Remove adjacent element disabled class
        $(this).closest(".product-option-item").next().removeClass("disabled");
        removeDisabledClass($(this));
      }

      if (!selectedVariant.toLowerCase().includes('frameset')) {
        // add slide up class
        $('#custom-fit-option').addClass('slide-up');
      } else {
        // set input to skip
        $('#bike-custom-fit-skip').val('skip');

        // loop through all the product-option-item class and remove the customize class
        $("[data-option-build]").each(function (index) {
          $(this).removeClass("customize");
          if (index === 0) {
            $(this).removeClass("disabled");
          }
        });
        $('.product-summary-container').removeClass('disabled');
        removeDisabledClass($(this), true, 90);
      }
      
      // unlock all buttons
      unlockingAllButtons($(this));
    }
  );

  // This feature is currently disabled
  $("[data-builder-package-options]").on("click", "button", async function (e) {
    e.preventDefault();

    // Check first if this option is already active
    if ($(this).hasClass("active")) return;

    // lock all buttons
    disabledAllButtons($(this));

    // clear cart
    await clearCart();

    // set bike-wheelset and bike-pedals to n/a
    $('#bike-wheelset').val('n/a');
    $('#bike-pedals').val('n/a');
    $('#bike-seatpost').val('n/a');

    // Re-add bike variant to cart
    await addToCart($('#bike-variant').val().split(":")[0]);

    // Re-add bike properties to cart
    if ($('#bike-custom-fit-skip').val() === 'n/a') {
      await addCustomFitProperties($('#bike-variant').val());
    } else {
      await changeBikeProperties($('#bike-variant').val());
    }

    // Remove active class from all the options
    $("[data-builder-package-options]").find("button").removeClass("active");
    $(this).addClass("active");

    // get build selected
    let selectedBuild = $(this).data("build");

    // Customize button clicked
    if (selectedBuild === "customize") {
      // show package options
      // loop through all the product-option-item class and remove the customize class
      $("[data-option-build]").each(function (index) {
        $(this).removeClass("customize");
        if (index === 0) {
          $(this).removeClass("disabled");
        }
      });

      $("[data-option-package]").each(function () {
        $(this).addClass("package");

        // Remove active class from all the options
        $(this).find("ul").children().each(function () {
          $(this).find('div').removeClass('active');
        });
      });
    }

    if (selectedBuild === "package") {
      // show package options
      // loop through all the product-option-item class and remove the customize class
      $("[data-option-package]").each(function () {
        $(this).removeClass("package").removeClass("disabled");
      });

      $("[data-option-build]").each(function () {
        $(this).addClass("customize disabled");

        // Remove active class from all the options
        $(this).find("ul").children().each(function () {
          $(this).find('div').removeClass('active');
        });
      });

      // Build Package
      // buildPackage(packageHandle);
      // get package handle
      let packageHandle = $(this).data("package");
      buildPackage(packageHandle);
    }

    removeDisabledClass($(this), true, 90);

    // unlock all buttons
    unlockingAllButtons($(this));
  });

  // # Wheelset Eventlistener
  $("[data-builder-part-wheelset]").on("click", "a", async function (e) {
    e.preventDefault();

    // Check first if available
    if($(this).find('.product-option-parts-inner-container').hasClass('active')) return;
    if(Number($(this).closest('li').data('available')) === 0) return;

    // lock all buttons
    disabledAllButtons($(this));

    // Get the selected wheelset id
    let selectedVariantID = getVariantID($(this).closest("li").data("variant-id"));

    // Change product image
    let wheelImage = $(this).closest("li").data("wheel-color");

    if (wheelImage.length > 0) {
      console.log("Wheel Image: ", wheelImage);
      // Get selected color
      const selectedColorName = $('[data-builder-variant-colors]').closest('.product-option-item').find('.product-option-label.color-option span').text();
      console.log("Selected Color: ", selectedColorName);
      const wheelImageObj = wheelImage.find((image) => image.color.toLowerCase() === selectedColorName.toLowerCase());
      console.log("Wheel Image: ", wheelImageObj);
      // format image
      const formattedImage = [{image: wheelImageObj.img}];
      imageCarousel(product, formattedImage);
    }
    // add parts to cart
    const response = await addPartsToCart(selectedVariantID, $('#bike-wheelset'));
    
    // update wheelset key
    $('#bike-wheelset').val(response.key);

    // update parts object
    parts['Wheelset'] = response.variant_title;

    // remove wheelset key from preselectedOptions object
    delete preselectedOptions['Wheelset'];

    // Remove active class from all the options
    $("[data-builder-part-wheelset]")
      .find(".product-option-parts-inner-container")
      .removeClass("active");

    const cartPrice = await updateCartTotalPrice();

    await updateBreadPayment(cartPrice);

    // set active price
    $(this).closest('.product-option-parts-container').attr('data-active-price', $(this).closest('li').data('price'));
    updateDisplayPrice($(this).closest('.product-option-parts-container'), $(this).closest('li'));

    $(this).find(".product-option-parts-inner-container").addClass("active");

    // Remove adjacent element disabled class
    $(this).closest(".product-option-item").next().removeClass("disabled");

    // Disable this for preselected feature
    // removeDisabledClass($(this), true, 90);

    // unlock all buttons
    unlockingAllButtons($(this));
  });

  // # Drivetrain Eventlistener
  $("[data-builder-part-drivetrain]").on("click", "a", async function (e) {
    e.preventDefault();

    // Check first if available
    if($(this).find('.product-option-parts-inner-container').hasClass('active')) return;
    if(Number($(this).closest('li').data('available')) === 0) return;

    // lock all buttons
    disabledAllButtons($(this));

    // Get the selected drivetrain id
    let selectedVariantID = getVariantID($(this).closest("li").data("variant-id"));

    // add parts to cart
    const response = await addPartsToCart(selectedVariantID, $('#bike-drivetrain'));
    
    // update drivetrain key
    $('#bike-drivetrain').val(response.key);

    // update parts object
    parts['Drivetrain'] = response.variant_title;

    // remove drivetrain key from preselectedOptions object
    delete preselectedOptions['drivetrain'];

    // Remove active class from all the options
    $("[data-builder-part-drivetrain]")
      .find(".product-option-parts-inner-container")
      .removeClass("active");

    const cartPrice = await updateCartTotalPrice();

    await updateBreadPayment(cartPrice);

    // set active price
    $(this).closest('.product-option-parts-container').attr('data-active-price', $(this).closest('li').data('price'));
    updateDisplayPrice($(this).closest('.product-option-parts-container'), $(this).closest('li'));

    $(this).find(".product-option-parts-inner-container").addClass("active");

    // Remove adjacent element disabled class
    $(this).closest(".product-option-item").next().removeClass("disabled");

    // Disable this for preselected feature
    // removeDisabledClass($(this), true, 90);

    // unlock all buttons
    unlockingAllButtons($(this));
  });

  $("[data-builder-part-cycling-computer]").on("click", "a", async function (e) {
    e.preventDefault();

    // Check first if available
    if($(this).find('.product-option-parts-inner-container').hasClass('active')) return;
    if(Number($(this).closest('li').data('available')) === 0) return;

    // lock all buttons
    disabledAllButtons($(this));

    // Get the selected cycling computer id
    let selectedVariantID = getVariantID($(this).closest("li").data("variant-id"));

    // add parts to cart
    const response = await addPartsToCart(selectedVariantID, $('#bike-cycling-computer'));
    
    // update cycling computer key
    $('#bike-cycling-computer').val(response.key);

    // update parts object
    parts['Cycling Computer'] = response.variant_title;

    // remove Cycling Computer key from preselectedOptions object
    delete preselectedOptions['cycling computer'];

    // Remove active class from all the options
    $("[data-builder-part-cycling-computer]")
      .find(".product-option-parts-inner-container")
      .removeClass("active");

    const cartPrice = await updateCartTotalPrice();

    await updateBreadPayment(cartPrice);

    // set active price
    $(this).closest('.product-option-parts-container').attr('data-active-price', $(this).closest('li').data('price'));
    updateDisplayPrice($(this).closest('.product-option-parts-container'), $(this).closest('li'));

    $(this).find(".product-option-parts-inner-container").addClass("active");

    // Remove adjacent element disabled class
    $(this).closest(".product-option-item").next().removeClass("disabled");

    // Disable this for preselected feature
    // removeDisabledClass($(this), true, 90);

    // unlock all buttons
    unlockingAllButtons($(this));
  });

  $("[data-builder-part-pedals]").on("click", "a", async function (e) {
    e.preventDefault();

    // Check first if available
    if($(this).find('.product-option-parts-inner-container').hasClass('active')) return;
    if(Number($(this).closest('li').data('available')) === 0) return;
    
    // lock all buttons
    disabledAllButtons($(this));

    // Get selected pedals id
    let selectedVariantID = getVariantID($(this).closest("li").data("variant-id"));

    // add parts to cart
    const response = await addPartsToCart(selectedVariantID, $('#bike-pedals'));

    // update pedals key
    $('#bike-pedals').val(response.key);

    // update parts object
    parts['Pedals'] = response.variant_title;

    // Delete pedals key from preselectedOptions object
    delete preselectedOptions['Pedals'];

    // Remove active class from all the options
    $("[data-builder-part-pedals]")
      .find(".product-option-parts-inner-container")
      .removeClass("active");

    const cartPrice = await updateCartTotalPrice();

    await updateBreadPayment(cartPrice);

    // set active price
    $(this).closest('.product-option-parts-container').attr('data-active-price', $(this).closest('li').data('price'));
    updateDisplayPrice($(this).closest('.product-option-parts-container'), $(this).closest('li'));

    $(this).find(".product-option-parts-inner-container").addClass("active");

    // Remove adjacent element disabled class
    $(this).closest(".product-option-item").next().removeClass("disabled");

    // Disable this for preselected feature
    // removeDisabledClass($(this), true, 90);

    // unlock all buttons
    unlockingAllButtons($(this));
  });

  $("[data-builder-part-seatpost]").on("click", "a", async function (e) {
    e.preventDefault();

    // Check first if available
    if($(this).find('.product-option-parts-inner-container').hasClass('active')) return;
    if(Number($(this).closest('li').data('available')) === 0) return;
    
    // lock all buttons
    disabledAllButtons($(this));

    // Get selected seatpost id
    let selectedVariantID = getVariantID($(this).closest("li").data("variant-id"));

    // add parts to cart
    const response = await addPartsToCart(selectedVariantID, $('#bike-seatpost'));

    // update seatpost key
    $('#bike-seatpost').val(response.key);

    // update parts object
    parts['Seatpost'] = response.variant_title;

    // Delete seatpost key from preselectedOptions object
    delete preselectedOptions['Seatpost'];

    // Remove active class from all the options
    $("[data-builder-part-seatpost]")
      .find(".product-option-parts-inner-container")
      .removeClass("active");

    const cartPrice = await updateCartTotalPrice();

    await updateBreadPayment(cartPrice);

    // set active price
    $(this).closest('.product-option-parts-container').attr('data-active-price', $(this).closest('li').data('price'));
    updateDisplayPrice($(this).closest('.product-option-parts-container'), $(this).closest('li'));

    $(this).find(".product-option-parts-inner-container").addClass("active");

    // Remove adjacent element disabled class
    $(this).closest(".product-option-item").next().removeClass("disabled");

    // Disable this for preselected feature
    // removeDisabledClass($(this), true, 90);

    // unlock all buttons
    unlockingAllButtons($(this));
  });

  // Suspension Travel
  $("[data-builder-part-suspension-travel]").on("click", "a", async function (e) {
    e.preventDefault();

    // Check first if available
    if($(this).find('.product-option-parts-inner-container').hasClass('active')) return;
    if(Number($(this).closest('li').data('available')) === 0) return;
    
    // lock all buttons
    disabledAllButtons($(this));

    // Get selected seatpost id
    let selectedVariantID = getVariantID($(this).closest("li").data("variant-id"));

    // add parts to cart
    const response = await addPartsToCart(selectedVariantID, $('#bike-suspension-travel'));

    // update seatpost key
    $('#bike-suspension-travel').val(response.key);

    // update parts object
    parts['Suspension Travel'] = response.variant_title;

    // Delete suspension travel key from preselectedOptions object
    delete preselectedOptions['Suspension Travel'];

    // Remove active class from all the options
    $("[data-builder-part-suspension-travel]")
      .find(".product-option-parts-inner-container")
      .removeClass("active");

    const cartPrice = await updateCartTotalPrice();

    await updateBreadPayment(cartPrice);

    $(this).find(".product-option-parts-inner-container").addClass("active");

    // Remove adjacent element disabled class
    $(this).closest(".product-option-item").next().removeClass("disabled");

    // Disable this for preselected feature
    // removeDisabledClass($(this), true, 90);

    // unlock all buttons
    unlockingAllButtons($(this));
  });

  // Suspension Travel
  $("[data-builder-part-suspension]").on("click", "a", async function (e) {
    e.preventDefault();

    // Check first if available
    if($(this).find('.product-option-parts-inner-container').hasClass('active')) return;
    if(Number($(this).closest('li').data('available')) === 0) return;
    
    // lock all buttons
    disabledAllButtons($(this));

    // Get selected seatpost id
    let selectedVariantID = getVariantID($(this).closest("li").data("variant-id"));

    // add parts to cart
    const response = await addPartsToCart(selectedVariantID, $('#bike-suspension'));

    // update seatpost key
    $('#bike-suspension').val(response.key);

    // update parts object
    parts['Suspension'] = response.variant_title;

    // Delete suspension key from preselectedOptions object
    delete preselectedOptions['Suspension'];

    // Remove active class from all the options
    $("[data-builder-part-suspension]")
      .find(".product-option-parts-inner-container")
      .removeClass("active");

    const cartPrice = await updateCartTotalPrice();

    await updateBreadPayment(cartPrice);

    // set active price
    $(this).closest('.product-option-parts-container').attr('data-active-price', $(this).closest('li').data('price'));
    updateDisplayPrice($(this).closest('.product-option-parts-container'), $(this).closest('li'));

    $(this).find(".product-option-parts-inner-container").addClass("active");

    // Remove adjacent element disabled class
    $(this).closest(".product-option-item").next().removeClass("disabled");

    // Disable this for preselected feature
    // removeDisabledClass($(this), true, 90);

    // unlock all buttons
    unlockingAllButtons($(this));
  });

  // Flat Protection
  $("[data-builder-part-flat-protection]").on("click", "a", async function (e) {
    e.preventDefault();

    // Check first if available
    if($(this).find('.product-option-parts-inner-container').hasClass('active')) return;
    if(Number($(this).closest('li').data('available')) === 0) return;
    
    // lock all buttons
    disabledAllButtons($(this));

    // Get selected bike-flat-protection id
    let selectedVariantID = getVariantID($(this).closest("li").data("variant-id"));

    // add parts to cart
    const response = await addPartsToCart(selectedVariantID, $('#bike-flat-protection'));

    // update bike-flat-protection key
    $('#bike-flat-protection').val(response.key);

    // update parts object
    parts['Flat Protection'] = response.variant_title;

    // Delete flat protection key from preselectedOptions object
    delete preselectedOptions['Flat Protection'];

    // Remove active class from all the options
    $("[data-builder-part-flat-protection]")
      .find(".product-option-parts-inner-container")
      .removeClass("active");

    const cartPrice = await updateCartTotalPrice();

    await updateBreadPayment(cartPrice);

    // set active price
    $(this).closest('.product-option-parts-container').attr('data-active-price', $(this).closest('li').data('price'));
    updateDisplayPrice($(this).closest('.product-option-parts-container'), $(this).closest('li'));

    $(this).find(".product-option-parts-inner-container").addClass("active");

    // Remove adjacent element disabled class
    $(this).closest(".product-option-item").next().removeClass("disabled");

    // Disable this for preselected feature
    // removeDisabledClass($(this), true, 90);

    // unlock all buttons
    unlockingAllButtons($(this));
  });

  // Frame Protection
  $("[data-builder-part-frame-protection]").on("click", "a", async function (e) {
    e.preventDefault();

    // Check first if available
    if($(this).find('.product-option-parts-inner-container').hasClass('active')) return;
    if(Number($(this).closest('li').data('available')) === 0) return;
    
    // lock all buttons
    disabledAllButtons($(this));

    // Get selected bike-frame-protection id
    let selectedVariantID = getVariantID($(this).closest("li").data("variant-id"));

    // add parts to cart
    const response = await addPartsToCart(selectedVariantID, $('#bike-frame-protection'));

    // update bike-frame-protection key
    $('#bike-frame-protection').val(response.key);

    // update parts object
    parts['Frame Protection'] = response.variant_title;

    // Delete frame protection key from preselectedOptions object
    delete preselectedOptions['Frame Protection'];

    // Remove active class from all the options
    $("[data-builder-part-frame-protection]")
      .find(".product-option-parts-inner-container")
      .removeClass("active");

    const cartPrice = await updateCartTotalPrice();

    await updateBreadPayment(cartPrice);

    // set active price
    $(this).closest('.product-option-parts-container').attr('data-active-price', $(this).closest('li').data('price'));
    updateDisplayPrice($(this).closest('.product-option-parts-container'), $(this).closest('li'));

    $(this).find(".product-option-parts-inner-container").addClass("active");

    // Remove adjacent element disabled class
    $(this).closest(".product-option-item").next().removeClass("disabled");

    // Disable this for preselected feature
    // removeDisabledClass($(this), true, 90);

    // unlock all buttons
    unlockingAllButtons($(this));
  });

  // Battery
  $("[data-builder-part-battery]").on("click", "a", async function (e) {
    e.preventDefault();

    // Check first if available
    if($(this).find('.product-option-parts-inner-container').hasClass('active')) return;
    if(Number($(this).closest('li').data('available')) === 0) return;
    
    // lock all buttons
    disabledAllButtons($(this));

    // Get selected bike-battery id
    let selectedVariantID = getVariantID($(this).closest("li").data("variant-id"));

    // add parts to cart
    const response = await addPartsToCart(selectedVariantID, $('#bike-battery'));

    // update bike-battery key
    $('#bike-battery').val(response.key);

    // update parts object
    parts['Battery'] = response.variant_title;

    // Delete battery key from preselectedOptions object
    delete preselectedOptions['Battery'];

    // Remove active class from all the options
    $("[data-builder-part-battery]")
      .find(".product-option-parts-inner-container")
      .removeClass("active");

    const cartPrice = await updateCartTotalPrice();

    await updateBreadPayment(cartPrice);

    // set active price
    $(this).closest('.product-option-parts-container').attr('data-active-price', $(this).closest('li').data('price'));
    updateDisplayPrice($(this).closest('.product-option-parts-container'), $(this).closest('li'));

    $(this).find(".product-option-parts-inner-container").addClass("active");

    // Remove adjacent element disabled class
    $(this).closest(".product-option-item").next().removeClass("disabled");

    // Disable this for preselected feature
    // removeDisabledClass($(this), true, 90);

    // unlock all buttons
    unlockingAllButtons($(this));
  });

  // Handlebar
  $("[data-builder-part-handlebar]").on("click", "a", async function (e) {
    e.preventDefault();

    // Check first if available
    if($(this).find('.product-option-parts-inner-container').hasClass('active')) return;
    if(Number($(this).closest('li').data('available')) === 0) return;
    
    // lock all buttons
    disabledAllButtons($(this));

    // Get selected bike-handlebar id
    let selectedVariantID = getVariantID($(this).closest("li").data("variant-id"));

    // add parts to cart
    const response = await addPartsToCart(selectedVariantID, $('#bike-handlebar'));

    // update bike-battery key
    $('#bike-handlebar').val(response.key);

    // update parts object
    parts['Handlebar'] = response.variant_title;

    // Delete battery key from preselectedOptions object
    delete preselectedOptions['Handlebar'];

    // Remove active class from all the options
    $("[data-builder-part-handlebar]")
      .find(".product-option-parts-inner-container")
      .removeClass("active");

    const cartPrice = await updateCartTotalPrice();

    await updateBreadPayment(cartPrice);

    // set active price
    $(this).closest('.product-option-parts-container').attr('data-active-price', $(this).closest('li').data('price'));
    updateDisplayPrice($(this).closest('.product-option-parts-container'), $(this).closest('li'));

    $(this).find(".product-option-parts-inner-container").addClass("active");

    // Remove adjacent element disabled class
    $(this).closest(".product-option-item").next().removeClass("disabled");

    // Disable this for preselected feature
    // removeDisabledClass($(this), true, 90);

    // unlock all buttons
    unlockingAllButtons($(this));
  });

  // Assembly Kit
  $("[data-builder-part-assembly-kit]").on("click", "a", async function (e) {
    e.preventDefault();

    // Check first if available
    if($(this).find('.product-option-parts-inner-container').hasClass('active')) return;
    if(Number($(this).closest('li').data('available')) === 0) return;
    
    // lock all buttons
    disabledAllButtons($(this));

    // Get selected bike-assembly-kit id
    let selectedVariantID = getVariantID($(this).closest("li").data("variant-id"));

    // add parts to cart
    const response = await addPartsToCart(selectedVariantID, $('#bike-assembly-kit'));

    // update bike-assembly-kit key
    $('#bike-assembly-kit').val(response.key);

    // update parts object
    parts['AssemblyKit'] = response.variant_title;

    // Delete assembly kit key from preselectedOptions object
    delete preselectedOptions['Assembly Kit'];

    // Remove active class from all the options
    $("[data-builder-part-assembly-kit]")
      .find(".product-option-parts-inner-container")
      .removeClass("active");

    const cartPrice = await updateCartTotalPrice();

    await updateBreadPayment(cartPrice);

    // set active price
    $(this).closest('.product-option-parts-container').attr('data-active-price', $(this).closest('li').data('price'));
    updateDisplayPrice($(this).closest('.product-option-parts-container'), $(this).closest('li'));

    $(this).find(".product-option-parts-inner-container").addClass("active");

    // Remove adjacent element disabled class
    $(this).closest(".product-option-item").next().removeClass("disabled");

    // Disable this for preselected feature
    // removeDisabledClass($(this), true, 90);

    // unlock all buttons
    unlockingAllButtons($(this));
  });

  // Accessories
  $("[data-builder-part-accessories]").on("click", "a", async function (e) {
    e.preventDefault();

    
    if(Number($(this).closest('li').data('available')) === 0) return;
    
    // lock all buttons
    disabledAllButtons($(this));

    // Check first if available
    if($(this).find('.product-option-parts-inner-container').hasClass('active')) {

      await removeFromCart($(this).closest("li").data("cart-key"));

      $(this).find(".product-option-parts-inner-container").removeClass("active");
    } else {
      // Get selected accessories id
      let selectedVariantID = getVariantID($(this).closest("li").data("variant-id"));
  
      // add parts to cart
      const response = await addPartsToCart(selectedVariantID, $('#bike-accessories'));
  
      // update bike-accessories key
      $('#bike-accessories').val(response.key);
  
      // update this parts attribute to cart key
      $(this).closest("li").attr("data-cart-key", response.key);
  
      // Remove active class from all the options
      // $("[data-builder-part-accessories]")
      //   .find(".product-option-parts-inner-container")
      //   .removeClass("active");

      $(this).find(".product-option-parts-inner-container").addClass("active");

      removeDisabledClass($(this), false, 90);

    }

    const cartPrice = await updateCartTotalPrice();

    await updateBreadPayment(cartPrice);  
    
    // set active price
    // $(this).closest('.product-option-parts-container').attr('data-active-price', $(this).closest('li').data('price'));
    // updateDisplayPrice($(this).closest('.product-option-parts-container'), $(this).closest('li'));

    // unlock all buttons
    unlockingAllButtons($(this));
  });

  // Package option items
  $('[data-builder-item-package]').on('click', 'a', async function (e) {
    e.preventDefault();
    // Check first if this option is already active
    if ($(this).find('.product-option-package-inner-container').hasClass('active')) return;

    // lock all buttons
    disabledAllButtons($(this));

    // Get the selected drivetrain id
    let selectedVariantID = getVariantID($(this).closest("li").data("variant-id"));

    // add parts to cart
    const response = await addPartsToCart(selectedVariantID, $('#bike-package'));

    // update package key
    $('#bike-package').val(response.key);

    // Remove active class from all the options
    $('[data-builder-item-package]').find('.product-option-package-inner-container').removeClass('active');
    $(this).find('.product-option-package-inner-container').addClass('active');

    await updateCartTotalPrice();

    removeDisabledClass($(this));

    // unlock all buttons
    unlockingAllButtons($(this));
  });

  // Add to cart button
  $("[data-add-to-cart]").on("click", async function (e) {
    e.preventDefault();
    // add disable class
    $(this).addClass("disabled");
    
    let buildParts = {
      "Frame Color": $('#bike-variant-color').val(),
      "Bike Size": $('#bike-variant-size').val(),
      "Bike Image": $('#bike-variant-color-image').val(),
      ...parts
    }

    if ($('#bike-custom-fit-skip').val() === 'n/a') {
      buildParts = {
        ...buildParts,
        "Custom Fit": "Yes",
        "Height": $('#bike-custom-fit-height').val(),
        "Weight": $('#bike-custom-fit-weight').val(),
        "Age": $('#bike-custom-fit-age').val(),
        "Inseam": $('#bike-custom-fit-inseam').val(),
        "Shoulder Width": $('#bike-custom-fit-shoulder-width').val(),
        "Arm Length": $('#bike-custom-fit-arm-length').val(),
        "Torso": $('#bike-custom-fit-torso').val(),
        "Gender": $('#bike-custom-fit-gender').val(),
        "Riding Position": $('#bike-custom-fit-riding-position').val(),
      }
    }

    const cleanObjectParts = []
    for (const key in preselectedOptions) {
      cleanObjectParts.push({id: preselectedOptions[key], quantity: 1});
    }
    if (cleanObjectParts.length > 0) {
      const request = await fetch('/cart/add.js', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({'items': cleanObjectParts}),
      })
      if(!request.ok) throw new Error('Failed to add to cart');
    }
    // add parts to cart
    // console.log("buildParts: ", buildParts);
    // console.log("bike-variant: ", $('#bike-variant').val());
    await addBikePartsProperties($('#bike-variant').val(), buildParts);
    // redirect to cart page
    window.location.href = "/cart";
  });

  // compare products
  $('[data-option-build] .product-option-label').on('click', 'a', function (e) {
    e.preventDefault();
    buildCompareProducts($(this))
    $('.custom-compare-container').removeClass('hidden');
    // remove body scroll
    $('body').css('overflow', 'hidden');
  });

  // Sizing Guide
  $('a[data-action-sizing-guide]').on('click', function (e) {
    e.preventDefault();

    //show popup for sizing guide
    $('.custom-sizing-guide-container').removeClass('hidden');
    $('.sizing-guide-container').find('h4').html(product.title + " Sizing Guide");

    // remove body scroll
    $('body').css('overflow', 'hidden');
  });

  // custom fit popup actions
  $('a[data-action-close]').on('click', function (e) {
    e.preventDefault();
    $('.custom-fit-container').addClass('hidden');
    $('.custom-compare-container').addClass('hidden');
    $('.custom-sizing-guide-container').addClass('hidden');

    // set body scroll default
    $('body').css('overflow', 'auto');
  });

  $('.product-option-size-container').on('click', 'button[data-action-custom-fit]', function () {
    $('.custom-fit-container').removeClass('hidden');

    // remove body scroll
    $('body').css('overflow', 'hidden');
  });

  $('.fit-container').on('click', 'a[data-action-next]', function (e) {
    e.preventDefault();

    // get this data item number
    let itemNumber = $(this).closest('li').next().find('.fit').data('item-number');

    // Set this parent to hidden
    $(this).closest('.fit').addClass('hidden');
    
    // Go up to parent li and find the next li and remove hidden class
    $(this).closest('li').next().find('.fit').removeClass('hidden');
    $(this).closest('li').next().find('.fit').find('input').focus();
    
    // Remove all active class from all the indicators
    $('.fit-indicator').find('li').removeClass('active');

    // set indicator by matching itemNumber with data-item-number
    $('.fit-indicator').find('li').each(function () {
      if ($(this).data('item-number') === itemNumber) {
        $(this).addClass('active');
      }
    });

  });

  // Fit container previous button
  $('.fit-container').on('click', 'a[data-action-prev]', function (e) {
    e.preventDefault();

    // get this data item number
    let itemNumber = $(this).closest('li').prev().find('.fit').data('item-number');

    // Set this parent to hidden
    $(this).closest('.fit').addClass('hidden');
    
    // Go up to parent li and find the previous li and remove hidden class
    $(this).closest('li').prev().find('.fit').removeClass('hidden');
    
    // Remove all active class from all the indicators
    $('.fit-indicator').find('li').removeClass('active');

    // set indicator by matching itemNumber with data-item-number
    $('.fit-indicator').find('li').each(function () {
      if ($(this).data('item-number') === itemNumber) {
        $(this).addClass('active');
      }
    });

  });

  // Fit container Inputs events
  $('.fit-container').on('keyup', 'input', function () {
    let value = $(this).val();
    let name = $(this).attr('name');
    $(`input[name="Custom ${name}"]`).val(value || "n/a");

    // remove disabled class from next button
    // check first if this input has value
    if (value === "") {
      $(this).closest('.fit').find('a[data-action-next]').addClass('disabled');
      $(this).closest('.fit').find('a[data-action-submit]').addClass('disabled');
      return;
    }
    $(this).closest('.fit').find('a[data-action-next]').removeClass('disabled');
    $(this).closest('.fit').find('a[data-action-submit]').removeClass('disabled');
  })

  // Fit container Radio events
  $('.fit-container').on('change', 'input[type="radio"]', function () {
    let value = $(this).val();
    let name = $(this).attr('name');
    // console.log("name: ", $(`input[name="custom ${name}"]`));
    $(`input[name="Custom ${name}"]`).val(value || "n/a");

    // remove disabled class from next button
    // check first if this input has value
    if (value === "") {
      $(this).closest('.fit').find('a[data-action-next]').addClass('disabled');
      $(this).closest('.fit').find('a[data-action-submit]').addClass('disabled');
      return;
    }
    $(this).closest('.fit').find('a[data-action-next]').removeClass('disabled');
    $(this).closest('.fit').find('a[data-action-submit]').removeClass('disabled');
  })

  // Fit container submit button
  $('.fit-container').on('click', 'a[data-action-submit]', async function (e) {
    e.preventDefault();
    // set fit skip to n/a
    $('#bike-custom-fit-skip').val('n/a');
    $('a[data-action-close').click();

    // loop through all the product-option-item class and remove the customize class
    $("[data-option-build]").each(function (index) {
      $(this).removeClass("customize");
      if (index === 0) {
        $(this).removeClass("disabled");
      }
    });

    $('.product-detail-size-heading-container').find('svg').removeClass('hidden');
    $('[data-action-custom-fit]').text('Resubmit Measurements');
    $('[data-action-skip]').addClass('hidden');

    $('.product-summary-container').removeClass('disabled');
    removeDisabledClass($('[data-builder-sizing-options]').find('a'), true, 90);

    // set bike properties
    await addCustomFitProperties($('#bike-variant').val());

  });

  // Start Over
  $('.product-action-reset').on('click', function (e) {
    e.preventDefault();
    resetBuilder();
    scrollToTarget($(".bike-builder-container"));

    //reload page
    window.location.reload();
  });
});
